/* اردو — Urdu */
const ur = {
  nav: {
    home: 'ہوم',
    imageConverter: 'تصویر کنورٹر',
    imageCompressor: 'تصویر کمپریسر',
    otherTools: 'دیگر ٹولز',
    resizeImage: 'تصویر کا سائز تبدیل کریں',
    cropImage: 'تصویر کراپ کریں',
    photoEditor: 'فوٹو ایڈیٹر',
    removeBackground: 'بیک گراؤنڈ ہٹائیں',
    watermarkImage: 'واٹر مارک',
    qrCodeGenerator: 'کیو آر کوڈ جنریٹر',
    qrCodeScanner: 'کیو آر کوڈ اسکینر',
    aboutUs: 'ہمارے بارے میں',
    faceBlur: 'چہرہ بلر',
  },
  hero: {
    heading: 'آپ کو ہر تصویری ٹول یہاں ملے گا',
    subheading: 'تصاویر کو تبدیل، کمپریس، ری سائز، کراپ، ایڈٹ اور ٹرانسفارم کرنے کے مفت آن لائن ٹولز۔ تمام پروسیسنگ آپ کے براؤزر میں ہوتی ہے — تیز، نجی اور محفوظ۔',
  },
  tools: {
    compressImage: { title: 'تصویر کمپریس کریں', desc: 'JPG، PNG، SVG اور GIF کو جگہ بچاتے ہوئے اور کوالٹی برقرار رکھتے ہوئے کمپریس کریں۔' },
    resizeImage: { title: 'تصویر ری سائز کریں', desc: 'فیصد یا پکسل سے اپنے طول و عرض متعین کریں اور اپنی JPG، PNG، SVG اور GIF تصاویر کا سائز تبدیل کریں۔' },
    cropImage: { title: 'تصویر کراپ کریں', desc: 'JPG، PNG یا GIF آسانی سے کراپ کریں۔' },
    convertToJpg: { title: 'JPG میں تبدیل کریں', desc: 'PNG، GIF، TIF، SVG، WEBP تصاویر کو بلک میں JPG میں تبدیل کریں۔' },
    convertFromJpg: { title: 'JPG سے تبدیل کریں', desc: 'JPG تصاویر کو PNG اور GIF میں تبدیل کریں۔' },
    qrCodeGenerator: { title: 'کیو آر کوڈ جنریٹر', desc: 'URLs، ٹیکسٹ، WiFi، رابطوں کے لیے حسب ضرورت QR کوڈز بنائیں۔' },
    qrCodeScanner: { title: 'کیو آر کوڈ اسکینر', desc: 'اپنے کیمرے سے یا تصویر اپ لوڈ کرکے فوری طور پر QR کوڈز اسکین کریں۔' },
    blurFace: { title: 'چہرہ بلر کریں', desc: 'رازداری کے لیے اپنی تصاویر میں چہروں کو خودکار طور پر دھندلا کریں۔' },
    removeBackground: { title: 'بیک گراؤنڈ ہٹائیں', desc: 'اعلیٰ درستگی کے ساتھ تصویر کے پس منظر کو تیزی سے ہٹائیں۔' },
    watermarkImage: { title: 'واٹر مارک', desc: 'سیکنڈوں میں اپنی تصاویر پر تصویر یا ٹیکسٹ لگائیں۔' },
  },
  whyChoose: {
    label: 'ہمیں کیوں چنیں',
    heading: 'تصاویر ایڈٹ کرنے کا ذہین طریقہ',
    subheading: 'دنیا بھر میں ہزاروں تخلیق کاروں، ڈیزائنرز اور ڈویلپرز کا بھروسہ۔',
    reasons: {
      fast: { title: 'بجلی کی رفتار', desc: 'تمام پروسیسنگ براہ راست آپ کے براؤزر میں ہوتی ہے۔ بیرونی سرورز پر کوئی اپ لوڈ نہیں۔' },
      private: { title: '100% نجی اور محفوظ', desc: 'آپ کی فائلیں آپ کے آلے سے کبھی نہیں نکلتیں۔ ہم آپ کی تصاویر کو ذخیرہ، شیئر یا استعمال نہیں کرتے۔' },
      noLimits: { title: 'کوئی حد نہیں، کوئی رجسٹریشن نہیں', desc: 'ہر ٹول جتنی بار چاہیں استعمال کریں — مکمل طور پر مفت۔' },
      quality: { title: 'پیشہ ورانہ کوالٹی', desc: 'ہمارے الگورتھم پیشہ ورانہ معیار کے نتائج فراہم کرتے ہیں۔' },
      batch: { title: 'بیچ پروسیسنگ', desc: 'ایک ساتھ متعدد فائلیں ہینڈل کریں۔' },
      everywhere: { title: 'ہر جگہ کام کرتا ہے', desc: 'ڈیسک ٹاپ، ٹیبلٹ اور موبائل پر کام کرنے والا مکمل ریسپانسو ڈیزائن۔' },
    },
    stats: {
      imagesProcessed: 'تصاویر پروسیس کی گئیں',
      countriesServed: 'ممالک میں خدمات',
      uptime: 'اپ ٹائم',
      freeTools: 'مفت ٹولز',
    },
  },
  footer: {
    tagline: 'مفت آن لائن تصویری ٹولز — سیکنڈوں میں اپنی تصاویر کنورٹ، کمپریس، ری سائز، کراپ اور ایڈٹ کریں۔ رجسٹریشن کی ضرورت نہیں۔',
    imageTools: 'تصویری ٹولز',
    moreTools: 'مزید ٹولز',
    company: 'کمپنی',
    contact: 'رابطہ',
    allRightsReserved: 'جملہ حقوق محفوظ ہیں۔',
    privacyPolicy: 'رازداری کی پالیسی',
    termsOfService: 'سروس کی شرائط',
  },
  faq: {
    badge: 'عمومی سوالات',
    heading: 'اکثر پوچھے جانے والے سوالات',
    subheading: 'اس ٹول کے بارے میں عام سوالات کے فوری جوابات۔',
    stillHaveQuestions: 'ابھی بھی سوالات ہیں؟ ہم مدد کے لیے حاضر ہیں!',
    reachOut: 'ہماری ٹیم سے رابطہ کریں',
    questionHeader: 'سوال',
  },

  contactForm: {
    badge: 'رابطہ کریں',
    title: 'ہم سے رابطہ کریں',
    subtitle: 'ہم آپ سے سننا پسند کریں گے۔ ہمیں پیغام بھیجیں!',
    nameLabel: 'نام',
    namePlaceholder: 'آپ کا پورا نام',
    emailLabel: 'ایمیل',
    emailPlaceholder: 'aap@email.com',
    subjectLabel: 'موضوع',
    subjectPlaceholder: 'یہ کس بارے میں ہے?',
    messageLabel: 'پیغام',
    messagePlaceholder: 'یہاں اپنا پیغام لکھیں…',
    errName: 'نام ضروری ہے',
    errEmail: 'ایمیل ضروری ہے',
    errEmailInvalid: 'درست ایمیل درج کریں',
    errSubject: 'موضوع ضروری ہے',
    errMessage: 'پیغام ضروری ہے',
    sending: 'بھیجکر…',
    send: 'پیغام بھیجیں',
    successTitle: 'پیغام بھیج دیا گیا!',
    successMsg: 'رابطہ کرنے کا شکریہ۔ ہم جلد ہی جواب دیں گے۔',
    sendAnother: 'دوسرا پیغام بھیجیں',
    sendError: 'کچھ غلط ہو گیا۔ براہ کرم دوبارہ کوشش کریں۔',
  },

  about: {
    label: 'ہمارے بارے میں',
    heading: 'تخلیق کاروں کے لیے، تخلیق کاروں کی طرف سے',
    subheading: 'ہم یقین رکھتے ہیں کہ طاقتور تصویری ٹولز مفت، تیز اور سب کے لیے قابل رسائی ہونے چاہئیں۔',
    missionTitle: 'ہمارا مشن',
    missionText: 'photremium.com ایک سادہ مقصد کے ساتھ بنایا گیا تھا: ویب پر سب سے آسان، تیز ترین اور سب سے نجی تصویر ایڈیٹنگ تجربہ فراہم کرنا۔',
    privacyTitle: 'رازداری سب سے پہلے',
    privacyText: 'ہم کبھی بھی آپ کی تصاویر کو ریموٹ سرورز پر اپ لوڈ، ذخیرہ یا پروسیس نہیں کرتے۔',
    techTitle: 'جدید ٹیکنالوجی',
    techText: 'WebAssembly، Canvas API اور جدید React سمیت جدید ترین ویب ٹیکنالوجیز سے بنایا گیا۔',
    communityTitle: 'کمیونٹی سے چلنے والا',
    communityText: 'ہر فیچر جو ہم بناتے ہیں حقیقی صارف فیڈ بیک سے متاثر ہے۔',
    globalTitle: 'عالمی رسائی',
    globalText: '120 سے زائد ممالک میں تخلیق کاروں کی طرف سے استعمال کیا جاتا ہے۔',
  },
  seo: {
    homeTitle: 'photremium.com — مفت آن لائن تصویر کنورٹر، کمپریسر اور ایڈیٹر',
    homeDesc: 'تصاویر کو مفت آن لائن کنورٹ، کمپریس، ری سائز، کراپ اور ایڈٹ کریں۔',
    homeKeywords: 'تصویر کنورٹر، تصویر کمپریسر، تصویر ری سائز، تصویر ایڈیٹر',
    aboutTitle: 'photremium.com کے بارے میں — ہمارا مشن اور کہانی',
    aboutDesc: 'photremium.com کے بارے میں جانیں، لاکھوں لوگوں کا بھروسہ مند مفت آن لائن تصویری ٹول کٹ۔',
    aboutKeywords: 'photremium.com کے بارے میں، تصویری ٹولز، مفت تصویر ایڈیٹر',
  },

  privacyPolicyPage: {
    seo: {
      title: 'رازداری کی پالیسی — Photremium | سرور اپ لوڈ نہیں، ڈیٹا اسٹوریج صفر',
      description: 'Photremium کی رازداری کی پالیسی بتاتی ہے کہ ہم آپ کی رازداری کیسے محفوظ رکھتے ہیں۔ تمام پروسیسنگ آپ کے براؤزر میں ہوتی ہے۔',
      ogTitle: 'رازداری کی پالیسی — Photremium | بغیر اپ لوڈ، بغیر اسٹوریج',
      ogDescription: 'آپ کی فائلیں آپ کے ڈیوائس میں رہتی ہیں۔ Photremium تمام پروسیسنگ لوکل براؤزر میں کرتا ہے۔',
      twitterTitle: 'رازداری کی پالیسی — Photremium',
      twitterDescription: '100% براؤزر پر مبنی ٹولز۔ نہ اپ لوڈ، نہ اسٹوریج، نہ ٹریکنگ۔',
      schemaName: 'رازداری کی پالیسی - Photremium',
      schemaDescription: 'Photremium رازداری پالیسی: نہ سرور اپ لوڈ، نہ ڈیٹا ذخیرہ۔',
    },
    hero: {
      badge: 'رازداری کی پالیسی',
      titlePrefix: 'آپ کی رازداری ہماری',
      titleHighlight: 'سب سے بڑی ترجیح',
      subPrefix: 'photremium.com ایک سادہ اصول پر بنا ہے —',
      subStrong: 'آپ کی فائلیں کبھی بھی آپ کے ڈیوائس سے باہر نہیں جاتیں',
      subSuffix: 'ہر امیج ٹول مکمل طور پر براؤزر میں چلتا ہے۔ نہ اپ لوڈ۔ نہ کلاؤڈ۔ نہ سمجھوتہ۔',
      effectiveLabel: 'نافذ العمل',
      lastUpdatedLabel: 'آخری اپ ڈیٹ',
      worldwideLabel: 'دنیا بھر میں لاگو',
    },
    trustCards: [
      { title: 'سرور اپ لوڈ نہیں', desc: 'آپ کی فائلیں ڈیوائس سے باہر نہیں جاتیں۔ تمام پروسیسنگ لوکل ہے۔' },
      { title: 'ڈیٹا اسٹوریج صفر', desc: 'ہم آپ، آپ کی تصاویر یا سرگرمی کے بارے میں کچھ محفوظ نہیں کرتے۔' },
      { title: 'کوئی ٹریکنگ نہیں', desc: 'نہ رویہ جاتی ٹریکنگ، نہ فنگرپرنٹنگ، نہ پروفائلنگ۔' },
      { title: 'GDPR موافق', desc: 'عالمی رازداری قوانین کے احترام کے ساتھ ڈیزائن کیا گیا۔' },
    ],
    contentsTitle: 'مشمولات',
    toc: {
      overview: 'جائزہ',
      'no-upload': 'سرور پروسیسنگ نہیں',
      'data-collect': 'ہم کون سا ڈیٹا لیتے ہیں',
      cookies: 'کوکیز اور اسٹوریج',
      'third-party': 'تھرڈ پارٹی سروسز',
      analytics: 'اینالیٹکس',
      children: 'بچوں کی رازداری',
      rights: 'آپ کے حقوق',
      security: 'سیکیورٹی',
      changes: 'پالیسی میں تبدیلیاں',
      contact: 'ہم سے رابطہ',
    },
    sections: {
      overview: {
        title: '1. جائزہ',
        subtitle: 'یہ پالیسی کس چیز کا احاطہ کرتی ہے',
        p1Prefix: 'یہ رازداری پالیسی وضاحت کرتی ہے کہ',
        p1Middle: '("ہم"، "ہمیں"، یا "ہمارا") آپ کی ذاتی معلومات کو کیسے سنبھالتا ہے - یا زیادہ درست طور پر،',
        p1Italic: 'سنبھالتا ہی نہیں',
        p1Suffix: 'جب آپ ہماری مفت آن لائن امیج ٹولز استعمال کرتے ہیں',
        p2: 'روایتی ویب ایپس کے برعکس جو فائلیں پروسیسنگ کے لیے ریموٹ سرورز پر بھیجتی ہیں، photremium.com جدید براؤزر APIs (Canvas API، WebAssembly، WebWorkers) استعمال کرتا ہے تاکہ ہر عمل آپ کے ڈیوائس پر لوکل طور پر ہو۔ نتیجہ: نہ ڈیٹا ٹرانسمشن، نہ اسٹوریج، نہ خطرہ۔',
        calloutLabel: 'سادہ خلاصہ:',
        calloutText: 'ہم آپ کی تصاویر نہیں دیکھ سکتے، دیکھنا نہیں چاہتے، اور ہماری ٹیکنالوجی خاص طور پر اس طرح بنائی گئی ہے کہ ہم کبھی دیکھ نہ سکیں۔',
      },
      noUpload: {
        title: '2. سرور پروسیسنگ نہیں — کبھی نہیں',
        subtitle: 'ہمارے ٹولز حقیقت میں کیسے کام کرتے ہیں',
        introPrefix: 'photremium.com کا ہر ٹول — امیج کنورٹر، کمپریسر، ریسائزر، بیک گراؤنڈ ریموور، فیس بلر، واٹرمارک، کراپ اور QR ٹولز — آپ کی فائلوں کو',
        introStrong: '100% آپ کے ویب براؤزر کے اندر',
        introSuffix: 'کلائنٹ سائیڈ JavaScript اور WebAssembly سے پروسیس کرتا ہے۔',
        points: [
          { label: 'فائل اپ لوڈ نہیں ہوتا۔', text: 'جب آپ فائل منتخب کرتے ہیں، یہ براؤزر File API سے میموری میں پروسیس ہوتی ہے اور نیٹ ورک پر نہیں بھیجی جاتی۔' },
          { label: 'سرور کو تصویر نہیں ملتی۔', text: 'ہمارا CDN صرف HTML، CSS، JavaScript اثاثے دیتا ہے؛ آپ کی فائلیں نہیں۔' },
          { label: 'عارضی ذخیرہ نہیں۔', text: 'نتائج صرف براؤزر میموری میں رہتے ہیں اور صفحہ چھوڑنے پر ختم ہو جاتے ہیں۔' },
          { label: 'آف لائن بھی کام کرتا ہے۔', text: 'ابتدائی لوڈ کے بعد زیادہ تر ٹولز بغیر انٹرنیٹ بھی چلتے ہیں، جو ثابت کرتا ہے سرور شامل نہیں۔' },
        ],
        callout: 'آپ خود جانچ سکتے ہیں: DevTools میں Network ٹیب کھولیں، تصویر منتخب کریں، اور تصدیق کریں کہ کوئی فائل ڈیٹا بیرونی سرور کو نہیں بھیجا جا رہا۔',
      },
      dataCollect: {
        title: '3. ہم کون سا ڈیٹا لیتے ہیں (اور نہیں لیتے)',
        subtitle: 'ڈیٹا پریکٹسز میں مکمل شفافیت',
        headers: { type: 'ڈیٹا کی قسم', collected: 'کیا جمع ہوتا ہے؟', whereWhy: 'کہاں / کیوں' },
        rows: [
          { type: 'آپ کی تصاویر / فائلیں', badge: 'کبھی نہیں', variant: 'green', showX: true, whereWhy: 'مکمل طور پر براؤزر میں پروسیس، کبھی منتقل نہیں' },
          { type: 'نام / ای میل', badge: 'کبھی نہیں', variant: 'green', showX: true, whereWhy: 'کسی ٹول کے لیے اکاؤنٹ یا سائن اپ ضروری نہیں' },
          { type: 'IP ایڈریس', badge: 'کم سے کم', variant: 'gray', showX: false, whereWhy: 'معیاری ویب لاگز <= 30 دن تک، شناخت سے منسلک نہیں' },
          { type: 'براؤزر / OS قسم', badge: 'کم سے کم', variant: 'gray', showX: false, whereWhy: 'براؤزر خود بھیجتا ہے؛ صرف مطابقت کے لیے' },
          { type: 'دیکھی گئی صفحات / کلکس', badge: 'مجموعی', variant: 'blue', showX: false, whereWhy: 'صرف گمنام اینالیٹکس (ذاتی شناخت نہیں)' },
          { type: 'زبان ترجیح', badge: 'صرف لوکل', variant: 'blue', showX: false, whereWhy: 'آپ کے ڈیوائس کے localStorage میں محفوظ، ہمیں نہیں بھیجا جاتا' },
          { type: 'ادائیگی / مالیاتی ڈیٹا', badge: 'کبھی نہیں', variant: 'green', showX: true, whereWhy: 'photremium.com مکمل مفت ہے، ادائیگی درکار نہیں' },
        ],
      },
      cookies: {
        title: '4. کوکیز اور لوکل اسٹوریج',
        subtitle: 'آپ کے ڈیوائس میں کیا محفوظ ہوتا ہے',
        intro: 'photremium.com نہ اشتہاری کوکیز، نہ کراس سائٹ ٹریکنگ کوکیز، اور نہ تھرڈ پارٹی کوکیز استعمال کرتا ہے۔ صرف ضروری سائٹ فنکشن کے لیے لوکل اسٹوریج استعمال ہوتا ہے۔',
        points: [
          { label: 'زبان ترجیح', text: 'localStorage میں محفوظ ہوتی ہے تاکہ اگلی بار بھی آپ کی زبان برقرار رہے۔ سرور کو نہیں بھیجی جاتی۔' },
          { label: 'تھیم / UI ترجیحات', text: 'اگر آپ ڈسپلے ترجیح سیٹ کریں، تو یہ صرف آپ کے ڈیوائس پر محفوظ ہوتی ہے۔' },
          { label: 'سیشن کوکیز نہیں۔', text: 'photremium.com میں لاگ اِن سسٹم نہیں، اس لیے سیشن ID کوکیز نہیں لکھی جاتیں۔' },
        ],
        callout: 'آپ کسی بھی وقت براؤزر سیٹنگز سے photremium.com کا لوکل اسٹوریج صاف کر سکتے ہیں (Settings -> Privacy -> Clear browsing data -> Cached data & cookies)۔ اس سے ٹول استعمال پر کوئی اثر نہیں پڑتا۔',
      },
      thirdParty: {
        title: '5. تھرڈ پارٹی سروسز',
        subtitle: 'ہم کون سی بیرونی سروسز کیوں استعمال کرتے ہیں',
        intro: 'photremium.com انفراسٹرکچر اور کارکردگی کے لیے محدود اور قابل اعتماد تھرڈ پارٹی سروسز استعمال کرتا ہے۔ ان میں سے کوئی بھی آپ کی تصاویر یا ذاتی شناختی معلومات حاصل نہیں کرتی۔',
        headers: { service: 'سروس', purpose: 'مقصد', dataShared: 'مشترک ڈیٹا', privacyPolicy: 'پرائیویسی پالیسی' },
        rows: [
          { service: 'Cloudflare Pages', purpose: 'سائٹ اثاثوں کی ہوسٹنگ اور CDN ترسیل', dataShared: 'IP ایڈریس، HTTP ہیڈرز (معیاری)', privacyLink: 'https://www.cloudflare.com/privacypolicy/', privacyText: 'cloudflare.com/privacypolicy' },
          { service: 'Font Awesome', purpose: 'CDN سے آئیکن فونٹس لوڈ', dataShared: 'IP ایڈریس (صرف CSS درخواست)', privacyLink: 'https://fontawesome.com/privacy', privacyText: 'fontawesome.com/privacy' },
          { service: 'Google Fonts', purpose: 'فونٹ لوڈنگ (اگر لاگو ہو)', dataShared: 'IP ایڈریس (صرف فونٹ درخواست)', privacyLink: 'https://policies.google.com/privacy', privacyText: 'policies.google.com' },
        ],
        outro: 'ہم آپ کا ڈیٹا مشتہرین، ڈیٹا بروکرز یا مذکورہ انفراسٹرکچر فراہم کنندگان کے علاوہ کسی تیسرے فریق کے ساتھ شیئر نہیں کرتے۔',
      },
      analytics: {
        title: '6. اینالیٹکس',
        subtitle: 'مجموعی اور رازداری دوست استعمالی ڈیٹا',
        introPrefix: 'یہ جاننے کے لیے کہ کون سے ٹول زیادہ استعمال ہو رہے ہیں اور سائٹ کو کیسے بہتر بنایا جائے، ہم',
        introStrong: 'مجموعی اور گمنام',
        introSuffix: 'استعمالی اعدادوشمار جمع کر سکتے ہیں، جیسے:',
        points: [
          'ہر ٹول کے صفحہ مناظر کی تعداد (صارف شناخت کے بغیر)',
          'ریفرل سورس (جیسے گوگل سرچ یا ڈائریکٹ لنک) — ذاتی ڈیٹا کے بغیر',
          'ملکی سطح کا جغرافیائی ڈیٹا (شہر یا درست مقام نہیں)',
          'مطابقت کے لیے براؤزر / ڈیوائس قسم',
        ],
        calloutLabel: 'کوئی ڈیٹا آپ سے ذاتی طور پر منسلک نہیں ہوتا۔',
        calloutText: 'ہم Google Analytics یا Meta Pixel استعمال نہیں کرتے۔ اگر اینالیٹکس ہو تو وہ privacy-first ٹولز ہوتے ہیں (مثلاً Plausible وغیرہ)۔',
      },
      children: {
        title: '7. بچوں کی رازداری',
        subtitle: 'بچوں کی حفاظت کے اصول',
        p1: 'photremium.com جان بوجھ کر 13 سال سے کم (یا EU میں GDPR کے تحت 16 سال سے کم) بچوں کا ذاتی ڈیٹا جمع نہیں کرتا۔ چونکہ ہم کسی بھی صارف کا ذاتی ڈیٹا جمع نہیں کرتے، اس لیے سائٹ سب کے لیے یکساں محفوظ ہے۔',
        p2Prefix: 'اگر آپ کو لگتا ہے کہ کسی بچے نے ہمارے رابطہ فارم سے ذاتی معلومات بھیجی ہیں تو فوراً اس ای میل پر رابطہ کریں',
        p2Suffix: 'اور ہم اسے فوری طور پر حذف کر دیں گے۔',
      },
      rights: {
        title: '8. آپ کے حقوق',
        subtitle: 'عالمی رازداری کے حقوق',
        intro: 'چونکہ photremium.com ذاتی شناختی معلومات جمع نہیں کرتا، زیادہ تر ڈیٹا حقوق سادہ طور پر لاگو ہوتے ہیں — آپ کے بارے میں رسائی، تصحیح یا حذف کے لیے کوئی ڈیٹا نہیں۔ پھر بھی ہم ان حقوق کو تسلیم اور احترام کرتے ہیں:',
        points: [
          { label: 'رسائی کا حق', text: 'آپ ہم سے اپنے متعلق موجود کسی بھی ڈیٹا کی کاپی مانگ سکتے ہیں۔ (گمنام لاگز کے علاوہ کچھ نہیں۔)' },
          { label: 'درستگی کا حق', text: 'غلط ذاتی معلومات کی تصحیح کی درخواست کر سکتے ہیں۔' },
          { label: 'مٹانے کا حق (Right to be forgotten)', text: 'آپ ہمارے پاس موجود ذاتی ڈیٹا حذف کرنے کی درخواست کر سکتے ہیں (GDPR Art. 17, CCPA)۔' },
          { label: 'اعتراض / آپٹ آؤٹ کا حق', text: 'آپ براؤزر سطح کے آپٹ آؤٹ یا ایڈ بلاک سے آئندہ اینالیٹکس سے باہر نکل سکتے ہیں۔' },
          { label: 'ڈیٹا پورٹیبلٹی کا حق', text: 'آپ کا کام براہ راست آپ کے ڈیوائس پر ڈاؤن لوڈ ہوتا ہے — برآمد کی علیحدہ درخواست ضروری نہیں۔' },
        ],
        callout: 'یہ حقوق دنیا بھر کے تمام صارفین پر لاگو ہوتے ہیں — ہم اعلیٰ معیار (GDPR) کو بنیادی معیار مانتے ہیں۔',
      },
      security: {
        title: '9. سیکیورٹی',
        subtitle: 'ہم آپ کے تجربے کو کیسے محفوظ رکھتے ہیں',
        intro: 'سب سے محفوظ ڈیٹا وہ ہے جو جمع ہی نہ کیا جائے۔ photremium.com کی کلائنٹ سائیڈ ساخت کی وجہ سے سرور بریچ بھی آپ کی فائلیں ظاہر نہیں کر سکتا کیونکہ وہ سرور پر ہوتی ہی نہیں۔ اضافی اقدامات:',
        points: [
          { label: 'HTTPS نفاذ', text: 'آپ کے براؤزر اور ہمارے CDN کے درمیان تمام ٹریفک TLS 1.2+ اور HSTS کے ذریعے خفیہ ہوتی ہے۔' },
          { label: 'Content Security Policy (CSP)', text: 'سخت ہیڈرز XSS اور inline script injection سے بچاتے ہیں۔' },
          { label: 'باقاعدہ dependency audits', text: 'ہم npm پیکجز کا باقاعدہ آڈٹ اور اپڈیٹ کرتے ہیں تاکہ معلوم کمزوریاں دور ہوں۔' },
        ],
        disclosurePrefix: 'ذمہ دارانہ اطلاع',
        disclosureTextPrefix: 'اگر آپ کو سیکیورٹی مسئلہ ملے تو ہمیں ای میل کریں',
        disclosureTextSuffix: 'اور ہم 48 گھنٹوں میں جواب دیں گے۔',
      },
      changes: {
        title: '10. اس پالیسی میں تبدیلیاں',
        subtitle: 'ہم اپ ڈیٹس کو کیسے سنبھالتے ہیں',
        intro: 'ہم وقتاً فوقتاً اپنی پریکٹسز، ٹولز یا قانونی تقاضوں کے مطابق اس رازداری پالیسی کو اپڈیٹ کر سکتے ہیں۔ جب ایسا ہو:',
        points: [
          { label: '"آخری اپ ڈیٹ"', text: 'صفحے کے اوپر تاریخ تبدیل کی جائے گی۔' },
          { label: 'اہم تبدیلیاں', text: 'کم از کم 30 دن کے لیے ہوم پیج پر نمایاں نوٹس کے ساتھ بتائی جائیں گی۔' },
          { label: 'پچھلے ورژنز', text: 'آرکائیو کیے جائیں گے اور درخواست پر دستیاب ہوں گے۔' },
        ],
        outro: 'تبدیلی کے بعد photremium.com کا استعمال اپڈیٹ پالیسی کی قبولیت سمجھا جائے گا۔ براہ کرم اس صفحے کا وقتاً فوقتاً جائزہ لیں۔',
      },
      contact: {
        title: '11. رابطہ اور ڈیٹا درخواستیں',
        subtitle: 'رازداری کے بارے میں رابطہ کریں',
        p1Prefix: 'اس رازداری پالیسی سے متعلق سوال، تشویش یا رسمی ڈیٹا درخواست کے لیے ہم سے رابطہ کریں۔ ہم رازداری سے متعلق درخواستوں کا جواب',
        p1Strong: '5 کاروباری دن',
      },
    },
    footer: {
      privacyQuestionsTitle: 'رازداری سے متعلق سوالات؟',
      privacyQuestionsDesc: 'اپنے سوالات یا ڈیٹا درخواستیں ہمیں بھیجیں، ہم جلد جواب دیں گے۔',
      versionHistoryTitle: 'ورژن ہسٹری',
      v2Label: 'v2.0 — بڑی نظرِ ثانی',
      v11Label: 'v1.1 — CCPA حقوق شامل کیے گئے',
      v10Label: 'v1.0 — ابتدائی پالیسی',
    },
  },

  common: {
    new: 'نیا!',
    download: 'ڈاؤن لوڈ',
    downloadAll: 'سب ڈاؤن لوڈ کریں',
    upload: 'اپ لوڈ',
    dragDrop: 'تصاویر یہاں ڈریگ اینڈ ڈراپ کریں، یا براؤز کرنے کے لیے کلک کریں',
    remove: 'ہٹائیں',
    reset: 'ری سیٹ',
    apply: 'لاگو کریں',
    cancel: 'منسوخ',
    clear: 'صاف کریں',
    close: 'بند کریں',
    save: 'محفوظ کریں',
    processing: 'پروسیسنگ...',
    noFiles: 'کوئی فائل منتخب نہیں',
    selectFiles: 'فائلیں منتخب کریں',
    or: 'یا',
    browseFiles: 'فائلیں براؤز کریں',
    dropHere: 'فائلیں یہاں چھوڑیں',
    quality: 'کوالٹی',
    width: 'چوڑائی',
    height: 'اونچائی',
    format: 'فارمیٹ',
    compression: 'کمپریشن',
    preview: 'پیش نظارہ',
    original: 'اصل',
    result: 'نتیجہ',
    before: 'پہلے',
    after: 'بعد',
    downloadAs: 'بطور ڈاؤن لوڈ کریں:',
    zip: 'کمپریس شدہ فائل',
    separate: 'الگ الگ',
    chooseFiles: 'فائلیں منتخب کریں',
    pasteHint: 'آپ تصاویر یہاں پیسٹ بھی کر سکتے ہیں',
    startOver: 'دوبارہ شروع کریں',
    startOverConfirm: 'تمام تصاویر حذف کر کے دوبارہ شروع کریں؟',
    addMoreImages: 'مزید تصاویر شامل کریں',
    addImage: 'تصویر شامل کریں',
    images: 'تصاویر',
    totalSize: 'کل سائز',
    size: 'سائز',
    type: 'قسم',
    unsavedEdits: 'آپ کے پاس محفوظ نہ کی گئی تبدیلیاں ہیں۔ صفحہ چھوڑیں؟',
    compareSlider: 'موازنہ سلائیڈر',
    toggleToolsPanel: 'ٹولز پینل ٹوگل کریں',
    closePanel: 'پینل بند کریں',
    zoomIn: 'زوم ان',
    zoomOut: 'زوم آؤٹ',
    fit: 'فٹ کریں',
    none: 'کوئی نہیں',
  },

  compressor: {
    seo: {
      uploadTitle: 'تصویر کمپریسر — JPG، PNG، SVG، GIF مفت کمپریس کریں | photremium.com',
      uploadDesc: 'JPG، PNG، SVG اور GIF تصاویر آن لائن مفت کمپریس کریں۔ فائلیں 80% تک چھوٹی۔',
      uploadKeywords: 'تصویر کمپریسر، jpg کمپریس، png کمپریس، تصویر سائز کم کریں',
      workspaceTitle: 'تصاویر کمپریس ہو رہی ہیں — photremium.com تصویر کمپریسر',
      workspaceDesc: 'کمپریشن لیول ایڈجسٹ کریں اور آپٹمائزڈ تصاویر ڈاؤن لوڈ کریں۔',
      workspaceKeywords: 'تصاویر کمپریس کریں، تصویر کمپریشن سلائیڈر',
    },
    title: 'تصویر کمپریسر',
    desc: 'JPG، PNG اور GIF تصاویر 80% تک چھوٹی کریں۔ تیز اور نجی۔',
    toCompress: 'کمپریس کرنے کے لیے',
    compressionForAll: 'تمام تصاویر کے لیے کمپریشن',
    summary: 'خلاصہ',
    originalSize: 'اصل سائز',
    compressed: 'کمپریسڈ',
    saved: 'بچایا',
    compressionLabel: 'کمپریشن:',
    compressing: 'کمپریس ہو رہا ہے…',
    compressDownload: 'کمپریس کریں اور ڈاؤن لوڈ کریں',
    lowQualityWarning: 'زیادہ کمپریشن تصویر کی وضاحت کو نمایاں طور پر کم کر سکتی ہے۔',
    blog: {
      tocTitle: 'فہرستِ مضامین',
      title: 'امیج کمپریسر بلاگ',
      formatsIntro: 'ہمارا ٹول تمام امیج فارمیٹس کو سپورٹ کرتا ہے، اس لیے آپ کسی بھی تصویر کو آسانی سے کمپریس کر سکتے ہیں۔ تمام فارمیٹس کی فہرست نیچے دی گئی ہے:',
      sections: [
        {
          id: 'imgcomp-card-1',
          title: '1. امیج کمپریسر کیا ہے؟',
          paragraphs: [
            'امیج کمپریسر ایک ٹول یا آن لائن سروس ہے جو تصویر کی بصری کوالٹی برقرار رکھتے ہوئے اس کا فائل سائز کم کرتی ہے۔ تاہم، بہت زیادہ کمپریشن کرنے سے کوالٹی میں واضح کمی آ سکتی ہے۔',
          ],
          listTitle: 'اقسام:',
          bullets: [
            'فقدانی دباؤ: اس قسم میں تصویر کا کچھ ڈیٹا حذف کر کے سائز کم کیا جاتا ہے۔ اس سے کوالٹی کم ہو سکتی ہے، مگر اکثر فرق انسانی آنکھ کو نمایاں محسوس نہیں ہوتا۔',
            'بلا فقدان دباؤ: اس میں تصویر کی بصری کوالٹی متاثر کیے بغیر فائل سائز کم کیا جاتا ہے۔',
          ],
        },
        {
          id: 'imgcomp-card-2',
          title: '2. ہمارا ٹول کیوں منتخب کریں؟',
          bullets: [
            'ہمارا مصنوعی ذہانت پر مبنی امیج کمپریسر تمام ڈیوائسز پر آسانی سے کام کرتا ہے اور بہترین نتائج دیتا ہے۔',
            'آپ ایک ہی کلک سے متعدد تصاویر (حتیٰ کہ 100+) ایک ساتھ کمپریس کر سکتے ہیں۔',
            'تصاویر کو ہمارے سرورز پر اپلوڈ کرنے کی ضرورت نہیں۔ تمام پروسیسنگ آپ کے لوکل براؤزر میں ہوتی ہے۔',
            'ہمارا امیج کمپریسر ہمیشہ کے لیے مکمل طور پر مفت ہے۔ آپ اسے اپنے دوستوں کے ساتھ شیئر بھی کر سکتے ہیں۔',
            'آپ اپنی ضرورت کے مطابق کمپریشن فیصد منتخب کر سکتے ہیں۔',
          ],
        },
        {
          id: 'imgcomp-card-3',
          title: '3. مرحلہ وار رہنمائی',
          steps: [
            {
              heading: '1. وہ تصویر/تصاویر منتخب کریں جنہیں آپ کمپریس کرنا چاہتے ہیں۔',
              bullets: [
                'تصویر/تصاویر کو ڈریگ اینڈ ڈراپ کر کے اپلوڈ باکس میں ڈالیں۔',
                'آپ کی بورڈ شارٹ کٹ کے ذریعے تصویر/تصاویر کو کاپی پیسٹ بھی کر سکتے ہیں۔',
                'منتخب کریں بٹن پر کلک کر کے فائل ایکسپلورر سے بھی تصاویر منتخب کی جا سکتی ہیں۔',
              ],
            },
            {
              heading: '2. پھر کمپریشن فیصد منتخب کریں۔',
              bullets: [
                'افقی سلائیڈر کے ذریعے کمپریشن فیصد آسانی سے منتخب کریں۔ درست نتائج کے لیے درج ذیل رینجز پر عمل کریں۔',
              ],
              table: {
                headers: ['کمپریشن فیصد', 'نتائج'],
                rows: [
                  ['1%  سے  40%', 'بہترین کوالٹی'],
                  ['41%  سے  60%', 'نارمل کوالٹی (تجویز کردہ)'],
                  ['61%  سے  100%', 'کمزور کوالٹی'],
                ],
              },
            },
            {
              heading: '3. بچائی گئی میموری چیک کریں۔',
              paragraphs: [
                'تمام میموری میٹرکس رن ٹائم پر دکھائے جاتے ہیں۔ آپ واضح طور پر دیکھ سکتے ہیں کہ کل میں سے کتنی میموری بچی ہے، اور اسی کے مطابق کمپریشن لیول ایڈجسٹ کر سکتے ہیں۔',
              ],
            },
            {
              heading: '4. ٹوگل بٹن سے ڈاؤن لوڈ آپشن منتخب کریں۔',
              bullets: [
                'کمپریس شدہ فائل: اگر آپ متعدد تصاویر کمپریس کر رہے ہیں تو یہ آپشن نظر آئے گا۔ اسے منتخب کرنے سے تمام کمپریسڈ تصاویر ایک ہی کمپریس شدہ فائل میں محفوظ ہو جائیں گی (زیادہ تصاویر کے لیے تجویز کردہ)۔',
                'الگ الگ: اس آپشن میں تمام تصاویر الگ الگ ڈاؤن لوڈ ہوں گی، ایک کمپریس شدہ فائل میں نہیں (کم تصاویر، 10 سے کم، کے لیے بہتر)۔',
              ],
            },
            {
              heading: '5. تصویر کمپریس کریں اور ڈاؤن لوڈ کریں۔',
              paragraphs: [
                'یہ بٹن منتخب کردہ ڈاؤن لوڈ آپشن کے مطابق تمام کمپریسڈ تصاویر خودکار طور پر ڈاؤن لوڈ کر دے گا۔',
              ],
            },
          ],
        },
        {
          id: 'imgcomp-card-4',
          title: '4. امیج کمپریسر کے فوائد۔',
          bullets: [
            'اسٹوریج لاگت میں کمی: تصاویر کمپریس ہونے سے ان کا سائز کم ہوتا ہے اور اسٹوریج کی ضرورت گھٹتی ہے۔',
            'تیز لوڈنگ: کمپریسڈ تصاویر تیزی سے لوڈ ہوتی ہیں جس سے ویب سائٹ یا ایپ کا صارف تجربہ بہتر ہوتا ہے۔',
            'جی میل حد کا حل: چونکہ جی میل اٹیچمنٹ کو 25MB تک محدود کرتا ہے، اس لیے کمپریشن سے آپ زیادہ فائلیں بھیج سکتے ہیں۔',
            'تیز شیئرنگ اور ٹرانسفر: بڑی فائلیں شیئر یا ٹرانسفر ہونے میں زیادہ وقت لیتی ہیں؛ کمپریشن وقت اور ڈیٹا بچاتا ہے۔',
            'پریزنٹیشن آپٹیمائزیشن: بغیر کمپریس تصاویر والی پریزنٹیشن بھاری ہو جاتی ہے، جبکہ کمپریس تصاویر کے ساتھ فائل سائز کافی کم رہتا ہے۔',
          ],
        },
        {
          id: 'imgcomp-card-5',
          title: '5. معاون فارمیٹس۔',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  converter: {
    seo: {
      uploadTitle: 'تصویر کنورٹر — PNG، JPG، WEBP، GIF، SVG مفت کنورٹ کریں | photremium.com',
      uploadDesc: 'JPG، PNG، WEBP، GIF، SVG، TIFF، BMP اور مزید کے درمیان تصاویر کنورٹ کریں۔ مفت آن لائن تصویر فارمیٹ کنورٹر — تیز، نجی، بغیر رجسٹریشن۔',
      uploadKeywords: 'تصویر کنورٹر، png سے jpg، jpg سے png، webp کنورٹر، تصویر فارمیٹ کنورٹر',
      workspaceKeywords: 'تصاویر کنورٹ کریں، تصویر فارمیٹ کنورٹر، بلک کنورٹ',

      routeKeywords: {

        'png-to-jpg': 'png تبدیل کرنے کے لیے jpg, png to jpg, تصویر کنورٹر، png سے jpg، jpg سے png، webp کنورٹر، تصویر فارمیٹ کنورٹر',

        'jpg-to-png': 'jpg تبدیل کرنے کے لیے png, jpg to png, تصویر کنورٹر، png سے jpg، jpg سے png، webp کنورٹر، تصویر فارمیٹ کنورٹر',

        'png-to-webp': 'png تبدیل کرنے کے لیے webp, png to webp, تصویر کنورٹر، png سے jpg، jpg سے png، webp کنورٹر، تصویر فارمیٹ کنورٹر',

        'jpg-to-webp': 'jpg تبدیل کرنے کے لیے webp, jpg to webp, تصویر کنورٹر، png سے jpg، jpg سے png، webp کنورٹر، تصویر فارمیٹ کنورٹر',

        'webp-to-jpg': 'webp تبدیل کرنے کے لیے jpg, webp to jpg, تصویر کنورٹر، png سے jpg، jpg سے png، webp کنورٹر، تصویر فارمیٹ کنورٹر',

        'webp-to-png': 'webp تبدیل کرنے کے لیے png, webp to png, تصویر کنورٹر، png سے jpg، jpg سے png، webp کنورٹر، تصویر فارمیٹ کنورٹر',

        'gif-to-jpg': 'gif تبدیل کرنے کے لیے jpg, gif to jpg, تصویر کنورٹر، png سے jpg، jpg سے png، webp کنورٹر، تصویر فارمیٹ کنورٹر',

        'gif-to-png': 'gif تبدیل کرنے کے لیے png, gif to png, تصویر کنورٹر، png سے jpg، jpg سے png، webp کنورٹر، تصویر فارمیٹ کنورٹر',

        'bmp-to-jpg': 'bmp تبدیل کرنے کے لیے jpg, bmp to jpg, تصویر کنورٹر، png سے jpg، jpg سے png، webp کنورٹر، تصویر فارمیٹ کنورٹر',

        'bmp-to-png': 'bmp تبدیل کرنے کے لیے png, bmp to png, تصویر کنورٹر، png سے jpg، jpg سے png، webp کنورٹر، تصویر فارمیٹ کنورٹر',

        'svg-to-png': 'svg تبدیل کرنے کے لیے png, svg to png, تصویر کنورٹر، png سے jpg، jpg سے png، webp کنورٹر، تصویر فارمیٹ کنورٹر',

        'svg-to-jpg': 'svg تبدیل کرنے کے لیے jpg, svg to jpg, تصویر کنورٹر، png سے jpg، jpg سے png، webp کنورٹر، تصویر فارمیٹ کنورٹر',

        'tiff-to-jpg': 'tiff تبدیل کرنے کے لیے jpg, tiff to jpg, تصویر کنورٹر، png سے jpg، jpg سے png، webp کنورٹر، تصویر فارمیٹ کنورٹر',

        'tiff-to-png': 'tiff تبدیل کرنے کے لیے png, tiff to png, تصویر کنورٹر، png سے jpg، jpg سے png، webp کنورٹر، تصویر فارمیٹ کنورٹر',

        'jpg-to-gif': 'jpg تبدیل کرنے کے لیے gif, jpg to gif, تصویر کنورٹر، png سے jpg، jpg سے png، webp کنورٹر، تصویر فارمیٹ کنورٹر',

        'png-to-gif': 'png تبدیل کرنے کے لیے gif, png to gif, تصویر کنورٹر، png سے jpg، jpg سے png، webp کنورٹر، تصویر فارمیٹ کنورٹر',

        'jpg-to-bmp': 'jpg تبدیل کرنے کے لیے bmp, jpg to bmp, تصویر کنورٹر، png سے jpg، jpg سے png، webp کنورٹر، تصویر فارمیٹ کنورٹر',

        'png-to-bmp': 'png تبدیل کرنے کے لیے bmp, png to bmp, تصویر کنورٹر، png سے jpg، jpg سے png، webp کنورٹر، تصویر فارمیٹ کنورٹر',

        'webp-to-gif': 'webp تبدیل کرنے کے لیے gif, webp to gif, تصویر کنورٹر، png سے jpg، jpg سے png، webp کنورٹر، تصویر فارمیٹ کنورٹر',

        'jpg-to-ico': 'jpg تبدیل کرنے کے لیے ico, jpg to ico, تصویر کنورٹر، png سے jpg، jpg سے png، webp کنورٹر، تصویر فارمیٹ کنورٹر',

        'png-to-ico': 'png تبدیل کرنے کے لیے ico, png to ico, تصویر کنورٹر، png سے jpg، jpg سے png، webp کنورٹر، تصویر فارمیٹ کنورٹر',

        'jpg-to-svg': 'jpg تبدیل کرنے کے لیے svg, jpg to svg, تصویر کنورٹر، png سے jpg، jpg سے png، webp کنورٹر، تصویر فارمیٹ کنورٹر',

        'png-to-svg': 'png تبدیل کرنے کے لیے svg, png to svg, تصویر کنورٹر، png سے jpg، jpg سے png، webp کنورٹر، تصویر فارمیٹ کنورٹر',

        'webp-to-svg': 'webp تبدیل کرنے کے لیے svg, webp to svg, تصویر کنورٹر، png سے jpg، jpg سے png، webp کنورٹر، تصویر فارمیٹ کنورٹر',

        'gif-to-svg': 'gif تبدیل کرنے کے لیے svg, gif to svg, تصویر کنورٹر، png سے jpg، jpg سے png، webp کنورٹر، تصویر فارمیٹ کنورٹر',

        'bmp-to-svg': 'bmp تبدیل کرنے کے لیے svg, bmp to svg, تصویر کنورٹر، png سے jpg، jpg سے png، webp کنورٹر، تصویر فارمیٹ کنورٹر',

        'tiff-to-svg': 'tiff تبدیل کرنے کے لیے svg, tiff to svg, تصویر کنورٹر، png سے jpg، jpg سے png، webp کنورٹر، تصویر فارمیٹ کنورٹر',

      },
    },
    title: 'تصویر کنورٹر',
    desc: 'JPG، PNG، WEBP، GIF، SVG، TIFF، BMP اور مزید کے درمیان تصاویر تبدیل کریں۔',
    toConvert: 'تبدیل کرنے کے لیے',
    convertSettings: 'کنورژن سیٹنگز',
    detected: 'پہچانا',
    convertTo: 'میں تبدیل کریں',
    converting: 'تبدیل ہو رہا ہے…',
    convertToFormat: '{format} میں تبدیل کریں',
    popularConversions: 'مشہور کنورژن',
    convertingTo: 'میں تبدیل ہو رہا ہے',
    all: 'سب',
  },

  resizer: {
    seo: {
      uploadTitle: 'تصویر ری سائز — JPG، PNG آن لائن مفت ری سائز کریں | photremium.com',
      uploadDesc: 'پکسل یا فیصد سے تصاویر آن لائن مفت ری سائز کریں۔ JPG، PNG، SVG اور GIF تصاویر کا سائز تبدیل کریں۔ بغیر رجسٹریشن۔',
      uploadKeywords: 'تصویر ری سائز، تصویر ری سائزر، jpg ری سائز، png ری سائز، تصویر کے طول و عرض تبدیل کریں',
      workspaceTitle: 'تصاویر ری سائز ہو رہی ہیں — photremium.com تصویر ری سائزر',
      workspaceDesc: 'تصاویر آن لائن مفت ری سائز کریں۔ بغیر رجسٹریشن۔',
      workspaceKeywords: 'تصویر ری سائز، تصویر ری سائزر، jpg ری سائز، png ری سائز',
    },
    title: 'تصویر ری سائز کریں',
    desc: 'پکسل، فیصد، سینٹی میٹر یا انچ میں طول و عرض سیٹ کریں اور فوری طور پر ری سائز کریں۔',
    toResize: 'ری سائز کرنے کے لیے',
    resizeSettings: 'ری سائز سیٹنگز',
    resizeBy: 'اس کے مطابق ری سائز کریں:',
    byPixels: 'پکسل سے',
    byPercentage: 'فیصد سے',
    byCentimeters: 'سینٹی میٹر سے',
    byInches: 'انچ سے',
    advanced: 'اعلی درجے',
    lockAspect: 'تناسب لاک کریں',
    unlockAspect: 'تناسب انلاک کریں',
    dontEnlarge: 'اگر اصل چھوٹا ہو تو بڑا نہ کریں',
    resizing: 'ری سائز ہو رہا ہے…',
    resizeDownload: 'ری سائز کریں اور ڈاؤن لوڈ کریں',
    blog: {
      tocTitle: 'مواد',
      title: 'تصویر ری سائزنگ بلاگ',
      sections: [
        {
          id: 'imgresize-card-1',
          title: '1. امیج ری سائزنگ ٹول کیوں استعمال کریں؟',
          paragraphs: [
            'امیج ری سائزنگ ٹول ایک ایسا سافٹ ویئر/ٹول ہے جو تصویر کے سائز (dimensions) کو تبدیل کرنے کے لیے استعمال ہوتا ہے۔ آپ اونچائی، چوڑائی یا دونوں تبدیل کر کے مطلوبہ سائز حاصل کر سکتے ہیں۔ یہ خاص طور پر سوشل میڈیا پلیٹ فارمز کے لیے مفید ہے جہاں اپلوڈ/پوسٹ کے سائز کی حد ہوتی ہے۔',
          ],
          listTitle: 'مثال کے طور پر:',
          bullets: [
            'Instagram پوسٹ: 1080 x 1080px (اسکوائر)',
            'Facebook پوسٹ: 1200 x 630px',
            'X (Twitter) پوسٹ: 1200 x 675px',
            'Instagram اسٹوری: 1080 x 1920px',
          ],
        },
        {
          id: 'imgresize-card-2',
          title: '2. ہمارا امیج ری سائزنگ ٹول کیوں منتخب کریں؟',
          paragraphs: [
            'ہمارا AI بیسڈ امیج ری سائزنگ ٹول آپ کو تیزی اور درستگی کے ساتھ تصاویر کا سائز تبدیل کرنے دیتا ہے۔ یہ ہر ڈیوائس پر ہمواری سے چلتا ہے اور کسی ایپ انسٹالیشن کی ضرورت نہیں ہوتی۔ تمام فیچرز آپ کے براؤزر میں آن لائن دستیاب ہیں۔',
          ],
          bullets: [
            'آپ ایک ساتھ متعدد تصاویر (حتیٰ کہ 100+) ری سائز کر سکتے ہیں۔ اگر ڈیوائس طاقتور ہو تو 400–500 تصاویر بھی چند سیکنڈ میں پروسیس ہو سکتی ہیں۔',
            'تمام پروسیسنگ آپ کے مقامی براؤزر میں ہوتی ہے۔ تصاویر کو ہمارے سرور پر اپلوڈ کرنے کی ضرورت نہیں، اس لیے تصاویر ڈیوائس سے باہر نہیں جاتیں۔',
            'ری سائزنگ کے لیے متعدد units سپورٹ کیے جاتے ہیں۔',
            'صرف ایک checkbox سے آپ تصویر کا aspect ratio برقرار رکھ سکتے ہیں۔',
            'متعدد تصاویر کے لیے آپ separate download یا ZIP download کا انتخاب کر سکتے ہیں۔',
          ],
        },
        {
          id: 'imgresize-card-3',
          title: '3. مرحلہ وار رہنمائی',
          steps: [
            {
              heading: 'سب سے پہلے وہ تصویر/تصاویر منتخب کریں جنہیں آپ ری سائز کرنا چاہتے ہیں۔ منتخب کرنے کے کئی طریقے ہیں۔',
              bullets: [
                'آپ تصاویر کو ڈریگ اینڈ ڈراپ باکس میں چھوڑ سکتے ہیں۔',
                'آپ “Ctrl + V” شارٹ کٹ سے تصاویر پیسٹ بھی کر سکتے ہیں۔',
                'یا “Choose Files” بٹن کے ذریعے فائل ایکسپلورر سے انتخاب کریں۔',
              ],
            },
            {
              heading: 'اس کے بعد ری سائزنگ یونٹ منتخب کریں۔ فی الحال دستیاب units یہ ہیں:',
              bullets: ['Pixels', 'Percentage', 'Centimeters', 'Inches'],
            },
            {
              heading: 'یونٹ منتخب کرنے کے بعد اونچائی اور چوڑائی سیٹ کریں۔ اگر چاہیں تو checkbox سے aspect ratio برقرار رکھیں۔',
            },
            {
              heading: 'اگر آپ اصل سائز سے بڑا نہیں کرنا چاہتے تو “Don’t enlarge if original is smaller” کو منتخب کریں۔',
            },
            {
              heading: 'پھر ڈاؤن لوڈ کا طریقہ منتخب کریں۔',
              bullets: [
                'اگر آپ تمام ری سائز شدہ تصاویر ایک zip فائل میں چاہتے ہیں تو ZIP منتخب کریں۔',
                'اگر ہر تصویر الگ ڈاؤن لوڈ کرنا چاہتے ہیں تو “separate” منتخب کریں۔',
              ],
            },
            {
              heading: 'آخر میں “Resize & Download” بٹن پر کلک کریں اور منتخب آپشن کے مطابق ڈاؤن لوڈ کریں۔',
            },
          ],
        },
        {
          id: 'imgresize-card-4',
          title: '4. امیج ری سائزنگ ٹول کے فوائد: اس ٹول کا سب سے بڑا فائدہ یہ ہے کہ یہ ویب پیجز اور سوشل میڈیا پوسٹس میں تصاویر کو درست طور پر فِٹ کرنے میں مدد دیتا ہے۔',
          tocLabel: '4. امیج ری سائزنگ ٹول کے فوائد',
          bullets: [
            'UX بہتر بنانا: تصاویر کا درست سائز اور مناسب جگہ بندی صارف کے تجربے کو نمایاں طور پر بہتر بناتی ہے۔',
            'سوشل میڈیا سپورٹ: کئی پلیٹ فارمز تصویروں کے سائز کی پابندی رکھتے ہیں، اور یہ ٹول آپ کو ان کے مطابق بنانے میں مدد دیتا ہے۔',
            'Responsive design: ویب ڈویلپرز کو مختلف ڈیوائسز کے لیے مختلف سائز کی تصاویر چاہیے ہوتی ہیں۔',
            'بہترین انتخاب: تصویر کو کھینچنے یا سختی سے کراپ کرنے کے بجائے ری سائزنگ عموماً بہتر نتیجہ دیتی ہے۔',
          ],
        },
        {
          id: 'imgresize-card-5',
          title: '5. سپورٹڈ فارمیٹس: ہمارا امیج ری سائزر تقریباً ہر قسم کے امیج فارمیٹ کو سپورٹ کرتا ہے۔ سپورٹڈ فارمیٹس یہ ہیں:',
          tocLabel: '5. سپورٹڈ فارمیٹس',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  cropper: {
    seo: {
      uploadTitle: 'تصویر کراپ — JPG، PNG، GIF مفت کراپ کریں | photremium.com',
      uploadDesc: 'JPG، PNG اور GIF تصاویر آن لائن آسانی سے کراپ کریں۔ پکسل منتخب کریں یا بصری ایڈیٹر استعمال کریں۔ مفت، تیز اور نجی۔',
      uploadKeywords: 'تصویر کراپ، تصویر کراپر، jpg کراپ، png کراپ، فوٹو کراپ آن لائن مفت',
      workspaceTitle: 'تصاویر کراپ ہو رہی ہیں — photremium.com تصویر کراپر',
      workspaceDesc: 'تصاویر آن لائن مفت کراپ کریں۔ پری سیٹ تناسب کے ساتھ بصری کراپ ایڈیٹر۔ بغیر رجسٹریشن۔',
      workspaceKeywords: 'تصویر کراپ، تصویر کراپر، jpg کراپ، png کراپ',
    },
    title: 'تصویر کراپ کریں',
    desc: 'بصری ایڈیٹر کے ساتھ JPG، PNG، GIF اور مزید تصاویر کراپ کریں۔',
    toCrop: 'کراپ کرنے کے لیے',
    cropSettings: 'کراپ سیٹنگز',
    widthPx: 'چوڑائی (px)',
    heightPx: 'اونچائی (px)',
    positionX: 'پوزیشن X (px)',
    positionY: 'پوزیشن Y (px)',
    cropTemplate: 'کراپ ٹیمپلیٹ',
    landscape: 'لینڈ اسکیپ',
    portrait: 'پورٹریٹ',
    square: 'مربع',
    freeform: 'آزاد',
    cropping: 'کراپ ہو رہا ہے…',
    cropDownload: 'کراپ کریں اور ڈاؤن لوڈ کریں',
    cropDownloadAll: 'سب کراپ کریں اور ڈاؤن لوڈ کریں',
    saveNext: 'محفوظ کریں اور اگلا',
    croppedNofTotal: 'آپ نے {total} میں سے {n} تصاویر کراپ کیے۔',
    downloadN: '{n} ڈاؤن لوڈ کریں',
    blog: {
      tocTitle: 'مواد',
      title: 'امیج کراپر بلاگ',
      sections: [
        {
          id: 'imgcrop-card-1',
          title: '1. امیج کراپر کیوں استعمال کریں؟',
          paragraphs: [
            'امیج کراپر ایک سافٹ ویئر ٹول ہے جو تصویر کو مطلوبہ شکل میں کاٹنے کے لیے استعمال ہوتا ہے۔ یہ وسیع پیمانے پر تصویر کے مطلوبہ حصے کو کاٹنے اور کسی بھی مقصد کے لیے بیرونی غیر ضروری حصہ ہٹانے کے لیے استعمال ہوتا ہے۔ یہ ایک کراپ باکس فراہم کرتا ہے جسے آپ اس جگہ کے مطابق ایڈجسٹ کر سکتے ہیں جہاں آپ کراپ کرنا چاہتے ہیں۔',
          ],
          listTitle: 'مثال کے طور پر:',
          bullets: [
            'گروپ فوٹو سے اپنی تصویر کاٹنا۔',
            'فہرست سے اپنا نام کاٹنا۔',
            'فل اسکرین اسنیپٹ سے پروگریس بار کاٹنا۔',
          ],
        },
        {
          id: 'imgcrop-card-2',
          title: '2. ہمارا امیج کراپر کیوں منتخب کریں؟',
          paragraphs: [
            'ہمارا امیج کراپر ٹول آپ کو تصاویر کو نہایت درستگی اور بہت تیزی سے کراپ کرنے دیتا ہے۔ آپ کو صرف کراپ باکس کا سائز اس جگہ پر ایڈجسٹ کرنا ہے جسے آپ کسی بھی تصویر سے کاٹنا چاہتے ہیں۔ تصویر کے انتخاب کے لیے تقریباً تمام امیج فارمیٹس سپورٹ کیے جاتے ہیں۔',
          ],
          bullets: [
            'آپ اتنی تصاویر کراپ کر سکتے ہیں جتنی آپ کا ڈیوائس سپورٹ کرتا ہے۔ اگر آپ کے پاس بہترین کارکردگی والا ڈیوائس ہے تو آپ ایک وقت میں 100+ تصاویر بھی بغیر کسی لگ یا مسئلے کے کراپ کر سکتے ہیں۔',
            'آپ کی تصاویر آپ کے مقامی براؤزر میں پروسیس ہوں گی۔ کسی تصویر کو ہمارے سرورز پر اپلوڈ کرنے کی ضرورت نہیں، اس لیے کوئی تصویر آپ کے ڈیوائس سے باہر نہیں جاتی۔ آپ اپنی ذاتی تصاویر کو بغیر کسی عدم تحفظ یا خطرے کے کراپ کر سکتے ہیں۔',
            'بہت سے ٹولز غیر درست امیج فارمیٹ کی خرابی دکھاتے ہیں۔ ہمارا امیج کراپر ٹول تقریباً تمام امیج فارمیٹس کی سپورٹ دے کر اس مسئلے کو حل کرتا ہے۔',
            'اگر آپ ایک وقت میں متعدد تصاویر کراپ کر رہے ہیں تو ہمارا ٹول آپ کو اپنی ترجیح کے مطابق کراپ کی گئی تصاویر کو ZIP یا الگ الگ تصاویر کی صورت میں ڈاؤن لوڈ کرنے دیتا ہے۔',
          ],
        },
        {
          id: 'imgcrop-card-3',
          title: '3. مرحلہ وار رہنمائی',
          steps: [
            {
              heading: '1. سب سے پہلے وہ تصویر منتخب کریں جسے آپ کراپ کرنا چاہتے ہیں۔ ہمارا امیج کراپر ایک وقت میں متعدد تصاویر منتخب کرنے کی بھی سہولت دیتا ہے۔',
              bullets: [
                'تصویر کو کراپ کرنے کے لیے اسے ڈراپ باکس میں ڈریگ اینڈ ڈراپ کریں۔',
                'آپ کراپ باکس میں موجود choose files بٹن پر کلک کر کے file explorer کے ذریعے بھی تصویر منتخب کر سکتے ہیں۔',
                'تصاویر کو ڈراپ باکس میں پیسٹ کرنے کے لیے Ctrl + V شارٹ کٹ بھی سپورٹ کیا جاتا ہے۔',
              ],
            },
            {
              heading: '2. پھر تصویر پر کراپ باکس کا سائز اور پوزیشن ایڈجسٹ کریں تاکہ اسے کاٹا جا سکے۔',
            },
            {
              heading: '3. آپ اونچائی، چوڑائی، افقی پوزیشن اور عمودی پوزیشن کی قدریں دستی طور پر درج کر کے بھی کراپ باکس ایڈجسٹ کر سکتے ہیں۔',
            },
            {
              heading: '4. آپ کچھ تیار شدہ ٹیمپلیٹس بھی استعمال کر سکتے ہیں:',
              bullets: [
                'لینڈاسکیپ(16:9)',
                'پورٹریٹ(9:16)',
                'اسکوائر(1:1)',
              ],
            },
            {
              heading: '5. پھر آپ کو ڈاؤن لوڈ کے آپشنز میں سے ایک منتخب کرنا ہوگا۔',
              bullets: [
                'ZIP: اگر آپ متعدد تصاویر کراپ کر رہے ہیں اور تمام کراپ شدہ تصاویر کو ایک ہی فائل کی صورت میں ڈاؤن لوڈ کرنا چاہتے ہیں تو یہ آپشن منتخب کریں۔',
                'Separate: اگر آپ تمام کراپ شدہ تصاویر الگ الگ ڈاؤن لوڈ کرنا چاہتے ہیں تو ٹوگل بٹن سے یہ آپشن منتخب کریں۔',
              ],
            },
            {
              heading: '6. پھر Crop & Download بٹن پر کلک کریں تاکہ آپ کی تمام کراپ شدہ تصاویر آپ کی preset dimensions کے مطابق ڈاؤن لوڈ ہو جائیں۔',
            },
          ],
        },
        {
          id: 'imgcrop-card-4',
          title: '4. امیج کراپر کے فوائد: امیج کراپر ٹول ڈیجیٹل دنیا میں کئی فوائد فراہم کرتا ہے۔ کچھ نیچے بیان کیے گئے ہیں:',
          tocLabel: '4. امیج کراپر کے فوائد',
          bullets: [
            'فریمز میں تصاویر کا درست فِٹ ہونا: امیج کراپر آپ کو تصاویر کو فریمز میں درست طور پر فِٹ کرنے میں مدد دیتا ہے۔ یہ فریمز کسی ویب پیج پر بھی ہو سکتے ہیں یا کسی سوشل میڈیا پلیٹ فارم پر بھی۔',
            'UX میں بہتری: چونکہ تصاویر کی درست جگہ بندی صارف کے تجربے کو بہتر بناتی ہے، اس لیے امیج کراپر UX کو کافی حد تک بہتر بنانے میں مدد کرتا ہے۔',
            'غیر ضروری بارڈر ہٹانا: آپ تصویر سے کسی بھی غیر ضروری بارڈر کو ہٹا کر اسے مزید بہتر بنا سکتے ہیں۔',
            'مطلوبہ آبجیکٹ کو الگ کرنا: آپ گروپ فوٹو سے اپنی تصویر کو الگ بھی کر سکتے ہیں۔',
            'اسٹوریج کی بچت: تصویر کو کراپ کرنا یقینی طور پر اسٹوریج بچاتا ہے کیونکہ تصویر کا خام حصہ کٹ جاتا ہے اور صرف مطلوبہ حصہ محفوظ ہوتا ہے۔',
            'پریزنٹیشن کی بہتری: چونکہ 10 بغیر کراپ تصاویر والی عام پریزنٹیشن تقریباً 30MB اسٹوریج لیتی ہے، اسی پریزنٹیشن میں کراپ تصاویر کے ساتھ تقریباً 10MB اسٹوریج لگ سکتی ہے۔',
          ],
        },
        {
          id: 'imgcrop-card-5',
          title: '5. سپورٹڈ فارمیٹس:',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  photoEditor: {
    seo: {
      title: 'آن لائن فوٹو ایڈیٹر — متن، اثرات اور فریم کے ساتھ تصاویر مفت ایڈٹ کریں | photremium.com',
      desc: 'تصاویر آن لائن مفت ایڈٹ کریں — متن، اثرات، فریم اور اسٹیکر شامل کریں۔ براؤزر میں چلتا ہے۔',
      keywords: 'فوٹو ایڈیٹر، آن لائن فوٹو ایڈیٹر، تصویر پر متن شامل کریں، تصویر اثرات، فوٹو فریم',
    },
    title: 'فوٹو ایڈیٹر',
    desc: 'تصاویر میں متن، اثرات، فریم اور اسٹیکر شامل کریں۔',
    toEdit: 'ایڈٹ کرنے کے لیے',
  },

  removeBg: {
    seo: {
      uploadTitle: 'تصویر سے بیک گراؤنڈ آن لائن مفت ہٹائیں | photremium.com',
      uploadDesc: 'اعلیٰ درستگی کے ساتھ تصویر کا بیک گراؤنڈ تیزی سے ہٹائیں۔ مفت آن لائن بیک گراؤنڈ ریموور — براؤزر میں چلتا ہے۔',
      uploadKeywords: 'بیک گراؤنڈ ہٹائیں، بیک گراؤنڈ ریموور، تصویر بیک گراؤنڈ ہٹائیں، شفاف بیک گراؤنڈ',
      workspaceTitle: 'بیک گراؤنڈ ہٹایا جا رہا ہے — photremium.com بیک گراؤنڈ ریموور',
      workspaceDesc: 'تصاویر کا بیک گراؤنڈ آن لائن مفت ہٹائیں۔ بغیر رجسٹریشن۔',
      workspaceKeywords: 'بیک گراؤنڈ ہٹائیں، بیک گراؤنڈ ریموور، شفاف بیک گراؤنڈ',
    },
    title: 'بیک گراؤنڈ ہٹائیں',
    desc: 'تصویر کا بیک گراؤنڈ فوری طور پر ہٹائیں۔ 100% مفت، براؤزر میں چلتا ہے۔',
    toRemoveBg: 'بیک گراؤنڈ ہٹائیں',
    backgroundRemover: 'بیک گراؤنڈ ریموور',
    processingProgress: 'پروسیسنگ کی پیشرفت',
    processingNImages: '{n} تصویر(یں) پروسیس ہو رہی ہیں…',
    allNProcessed: 'تمام {n} تصویر(یں) پروسیس ہو گئیں!',
    nOfTotalDone: '{n} / {total} مکمل',
    fileName: 'فائل نام',
    dimensions: 'طول و عرض',
    status: 'صورتحال',
    statusDone: '✓ مکمل',
    statusProcessing: '⏳ پروسیسنگ',
    statusError: '✗ خرابی',
    statusPending: '⏸ زیر انتظار',
    badgeDone: 'مکمل',
    badgeProcessing: 'پروسیسنگ…',
    badgeError: 'خرابی',
    removingBg: 'بیک گراؤنڈ ہٹایا جا رہا ہے…',
    retry: 'دوبارہ کوشش کریں',
    downloading: 'ڈاؤن لوڈ ہو رہا ہے…',
    nextImage: 'اگلی تصویر',
  },

  watermark: {
    seo: {
      uploadTitle: 'تصویر واٹر مارک — متن اور لوگو واٹر مارک مفت شامل کریں | photremium.com',
      uploadDesc: 'سیکنڈوں میں تصاویر پر متن یا تصویری واٹر مارک شامل کریں۔ مفت، تیز اور نجی۔',
      uploadKeywords: 'واٹر مارک تصویر، واٹر مارک شامل کریں، متن واٹر مارک، لوگو واٹر مارک',
      workspaceTitle: 'تصاویر پر واٹر مارک لگایا جا رہا ہے — photremium.com واٹر مارک ٹول',
      workspaceDesc: 'تصاویر میں واٹر مارک آن لائن مفت شامل کریں۔ بغیر رجسٹریشن۔',
      workspaceKeywords: 'واٹر مارک تصویر، واٹر مارک شامل کریں، متن واٹر مارک',
    },
    title: 'واٹر مارک شامل کریں',
    desc: 'تصاویر میں متن یا لوگو واٹر مارک شامل کریں۔',
    toWatermark: 'واٹر مارک کے لیے',
    watermarkTools: 'واٹر مارک ٹولز',
    addText: 'متن شامل کریں',
    addImage: 'تصویر شامل کریں',
    layersN: 'لیئرز ({n})',
    noLayers: 'ابھی تک کوئی لیئر شامل نہیں کی گئی',
    textLayer: 'متن لیئر',
    imageLayer: 'تصویر لیئر',
    watermarkDownloadAll: 'واٹر مارک اور سب ڈاؤن لوڈ کریں',
    watermarkDownload: 'واٹر مارک اور ڈاؤن لوڈ کریں',
    nextImage: 'اگلی تصویر',
    selectToEdit: 'ترمیم شروع کرنے کے لیے کوئی بھی تصویر یا متن منتخب کریں',
    bold: 'موٹا',
    italic: 'ترچھا',
    underline: 'خط کشیدہ',
    bgColor: 'پس منظر رنگ',
    textColor: 'متن رنگ',
    alignLeft: 'بائیں ترتیب',
    alignCenter: 'وسط',
    alignRight: 'دائیں ترتیب',
    opacity: 'شفافیت',
    stroke: 'خط',
    strokeWidth: 'خط موٹائی',
    strokeColor: 'خط رنگ',
    tileRepeat: 'ٹائل / دوہرائیں',
    tilePattern: 'ٹائل پیٹرن',
    spacing: 'وقفہ',
    snapToCenter: 'مرکز میں اسنیپ کریں',
    duplicate: 'نقل کریں',
    delete: 'حذف کریں',
    flipHorizontal: 'افقی پلٹائیں',
    flipVertical: 'عمودی پلٹائیں',
    rotateLeft: 'بائیں گھمائیں',
    rotateRight: 'دائیں گھمائیں',
    cornerRadius: 'کونے کا رداس',
    borderStroke: 'سرحد / خط',
    borderWidth: 'سرحد موٹائی',
    color: 'رنگ',
    style: 'انداز',
    hide: 'چھپائیں',
    show: 'دکھائیں',
    lock: 'لاک کریں',
    unlock: 'انلاک کریں',
    solid: 'ٹھوس',
    dashed: 'ڈیشڈ',
    dotted: 'نقطے دار',
    double: 'دوہرا',
    tileSingle: 'واحد',
    tile2x2: '2×2 گرڈ',
    tile3x3: '3×3 گرڈ',
    removeAllConfirm: 'تمام تصاویر اور واٹر مارک ہٹائیں؟',
    dimMismatch: 'اپلوڈ کی گئی تصاویر کے مختلف طول و عرض ہیں۔ بہترین نتائج کے لیے یکساں ریزولوشن والی تصاویر اپلوڈ کریں۔',
    clearBackground: 'پس منظر صاف کریں',
    typeHere: 'یہاں ٹائپ کریں...',
    linkCorners: 'کونے جوڑیں',
    separateCorners: 'کونے الگ کریں',
    blog: {
      tocTitle: 'فہرست',
      sections: [
        {
          id: 'wm-blog-intro',
          tocLabel: 'واٹرمارک ٹول کا تعارف',
          title: 'اپنی تصاویر میں آن لائن واٹرمارک کیسے شامل کریں - Photremium واٹرمارک ٹول کی مکمل گائیڈ',
          paragraphs: [
            'آپ نے ابھی ایک خوبصورت تصویر کی ایڈیٹنگ مکمل کی ہے۔ شاید یہ آپ کی دکان کے لیے ایک پروڈکٹ شاٹ ہے، کسی کلائنٹ سیشن کی پورٹریٹ تصویر ہے، یا کوئی ڈیجیٹل آرٹ ورک ہے جسے آپ نے گھنٹوں لگا کر بہتر بنایا ہے۔ اور اب وہ سوال آتا ہے جس کا ہر تخلیق کار کو آخرکار سامنا کرنا پڑتا ہے: اسے شیئر کرنے سے پہلے کیسے محفوظ کیا جائے؟',
            'اکثر پیشہ ور جس حل پر پہنچتے ہیں وہ واٹرمارک ہے - اور اس کی وجہ بھی واضح ہے۔ صحیح جگہ پر لگایا گیا واٹرمارک آپ کے کام پر ایک مستقل دستخط کی طرح ہوتا ہے، اسے قابلِ شناخت بناتا ہے، برانڈڈ رکھتا ہے، اور چوری کرنا کافی مشکل بنا دیتا ہے۔',
            'مسئلہ یہ ہے کہ آن لائن دستیاب زیادہ تر ٹولز یا تو بہت بھدے ہوتے ہیں، یا سبسکرپشن کے پیچھے بند ہوتے ہیں، یا اتنا بھاری واٹرمارک بناتے ہیں کہ تصویر ہی خراب ہو جاتی ہے۔',
            'Photremium کا Watermark Image ٹول انہی تمام مسائل کو حل کرنے کے لیے بنایا گیا تھا۔ یہ مکمل طور پر براؤزر پر مبنی، مفت، بغیر اکاؤنٹ کی ضرورت کے واٹرمارک ورک اسپیس ہے جو براہِ راست آپ کے براؤزر میں چلتا ہے اور آپ کی فائلیں کبھی سرور پر اپلوڈ نہیں کرتا۔ سب کچھ مقامی رہتا ہے، سب کچھ تیز رہتا ہے، اور تخلیقی کنٹرول کی سطح وہی فراہم کرتی ہے جس کی آپ ایک ڈیسک ٹاپ سافٹ ویئر سے توقع کریں گے۔ اس گائیڈ میں ہم دیکھیں گے کہ یہ بالکل کیسے کام کرتا ہے، یہ کس کے لیے ہے، اور ہر بار بہترین نتائج کیسے حاصل کیے جائیں۔',
          ],
        },
        {
          id: 'wm-blog-what-is',
          tocLabel: 'واٹرمارک کیا ہے',
          title: 'واٹرمارک کیا ہے اور یہ کیوں اہم ہے؟',
          paragraphs: [
            'ٹول کے اندر جانے سے پہلے یہ سمجھنا اہم ہے کہ واٹرمارک کیا کرتا ہے اور کیوں بہت سے فوٹوگرافرز، ڈیزائنرز اور مواد بنانے والے اسے لازمی سمجھتے ہیں۔',
            'واٹرمارک ایک مرئی اوورلے ہے جو تصویر پر شامل کیا جاتا ہے - عام طور پر متن، لوگو، یا کاپی رائٹ علامت - جو مواد کے خالق یا مالک کی شناخت کرتا ہے۔ میٹاڈیٹا کے برعکس (جو فائل کے اندر چھپا ہوتا ہے اور چند سیکنڈ میں ہٹایا جا سکتا ہے) واٹرمارک خود تصویر کے اندر بصری طور پر شامل ہوتا ہے۔ آپ اسے صرف رائٹ کلک کر کے اس طرح نہیں ہٹا سکتے کہ تصویر کے معیار کو واضح نقصان نہ پہنچے۔',
          ],
          subSections: [
            {
              title: 'خالقین واٹرمارک کیوں استعمال کرتے ہیں',
              paragraphs: [
                'اپنی تصاویر پر واٹرمارک لگانے کی عملی وجوہات تین بنیادی مسائل کے گرد گھومتی ہیں۔',
              ],
              bullets: [
                'ملکیت کی شناخت۔ جب آپ کا کام سوشل میڈیا، Pinterest بورڈز، یا بلاگ پوسٹس میں شامل ہو کر پھیلتا ہے تو اصل نسبت اکثر ختم ہو جاتی ہے۔ واٹرمارک یقینی بناتا ہے کہ آپ کا نام یا برانڈ تصویر کے ساتھ جہاں بھی جائے، ساتھ رہے۔',
                'چوری سے روک تھام۔ زیادہ تر عام تصویر چور آسان راستہ تلاش کرتے ہیں۔ پیشہ ورانہ نظر آنے والا واٹرمارک، خاص طور پر جو اچھی طرح رکھا گیا ہو اور قدرے شفاف ہو، واضح پیغام دیتا ہے: یہ تصویر کسی ایسے شخص کی ہے جو اپنے کام کی قدر کرتا ہے۔',
                'کلائنٹ پورٹ فولیو تحفظ۔ وہ فوٹوگرافرز جو حتمی ادائیگی سے پہلے کلائنٹس کو پیش نظارہ بھیجتے ہیں، اکثر واٹرمارک استعمال کرتے ہیں تاکہ پیش نظارہ بغیر بل ادا کیے استعمال نہ ہو سکے۔ ہلکا سا واٹرمارک اس مقصد کو پورا کرتا ہے اور پیش نظارہ کو بے حد پریشان کن بھی نہیں بناتا۔',
              ],
            },
            {
              title: 'کون اپنی تصاویر واٹرمارک کرے',
              paragraphs: [
                'اگر آپ درج ذیل کسی بھی زمرے میں آتے ہیں تو آن لائن شیئر کرنے سے پہلے اپنی تصاویر پر واٹرمارک لگانا اختیاری نہیں - ضروری ہے:',
              ],
              bullets: [
                'فری لانس فوٹوگرافرز جو کلائنٹس کے ساتھ گیلریاں شیئر کرتے ہیں',
                'گرافک ڈیزائنرز جو پورٹ فولیو نمونے تقسیم کرتے ہیں',
                'ای کامرس فروخت کنندگان جو لائسنسنگ ڈیلز سے پہلے پروڈکٹ فوٹو دکھاتے ہیں',
                'ڈیجیٹل آرٹسٹ جو سوشل پلیٹ فارمز پر کام شیئر کرتے ہیں',
                'بلاگرز اور مواد بنانے والے جن کی تصاویر بار بار دوبارہ استعمال کی جاتی ہیں',
                'اسٹاک فوٹو کنٹریبیوٹرز جو ایک پہچانا جانے والا برانڈ بنا رہے ہیں',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-workspace',
          tocLabel: 'ورک اسپیس پینلز',
          title: 'Photremium کے واٹرمارک ٹول کے اندر: ایک تین پینل والی ورک اسپیس جو حقیقی ورک فلو کے لیے بنائی گئی ہے',
          paragraphs: [
            'Photremium واٹرمارک ٹول کو بنیادی آن لائن واٹرمارکرز سے ممتاز بنانے والی چیز اس کا ورک اسپیس ڈیزائن ہے۔ سادہ "متن لکھیں، پوزیشن منتخب کریں، ختم" والے طریقے کی بجائے، یہ ٹول تین پینل والی ترتیب فراہم کرتا ہے جو پیشہ ورانہ ڈیزائن سافٹ ویئر کی یاد دلاتی ہے - فرق صرف یہ ہے کہ یہ مکمل طور پر آپ کے براؤزر میں چلتا ہے، بغیر کسی انسٹالیشن کے۔',
          ],
          subSections: [
            {
              title: 'بایاں کینوس پینل',
              paragraphs: [
                'کینوس پینل اسکرین کا سب سے بڑا حصہ گھیرتا ہے اور آپ کو بالکل دکھاتا ہے کہ واٹرمارک لگنے کے بعد تصویر کیسی نظر آتی ہے۔ آپ جو بھی تبدیلی کرتے ہیں - اوپیسٹی ایڈجسٹ کرنا، ٹیکسٹ لیئر کی جگہ بدلنا، لوگو کا سائز تبدیل کرنا - وہ فوراً کینوس پر ظاہر ہو جاتی ہے۔ یہاں کوئی "پری ویو" بٹن نہیں ہے۔ جو آپ دیکھ رہے ہیں وہی نتیجہ ہے۔',
                'کینوس میں ایک بلٹ اِن زوم ٹول بار بھی شامل ہے، جس سے آپ درست صف بندی کے لیے زوم اِن اور مجموعی منظر کے لیے زوم آؤٹ کر سکتے ہیں۔ Zoom-to-fit فیچر خودکار طور پر آپ کی اسکرین کے سائز کے مطابق بہترین ابتدائی اسکیل کا حساب لگاتا ہے، اس لیے ہائی ریزولوشن تصاویر بھی آرام دہ ورک سائز میں کھلتی ہیں۔ جب آپ کسی لیئر کو تصویر کے افقی یا عمودی مرکز کے قریب گھسیٹتے ہیں تو الائنمنٹ گائیڈز خود بخود ظاہر ہوتے ہیں اور واٹرمارک کو بالکل مرکز میں لا کر سنبھالتے ہیں، ایسی درستگی کے ساتھ جو عام طور پر صرف Photoshop میں ملتی ہے۔',
              ],
            },
            {
              title: 'دایاں سیٹنگز پینل',
              paragraphs: [
                'دایاں پینل کنٹرول سینٹر ہے۔ یہیں آپ اپنے واٹرمارک لیئرز منظم کرتے ہیں، ان کی شکل و صورت بدلتے ہیں، اور آخری ایکسپورٹ شروع کرتے ہیں۔ ڈیسک ٹاپ پر یہ اسکرین کے دائیں طرف مستقل رہتا ہے۔ موبائل ڈیوائسز پر یہ نیچے سے سلائیڈ ہو کر bottom sheet کی شکل اختیار کرتا ہے - ایک floating gear بٹن کے ذریعے - تاکہ کام کرتے وقت آپ کے کینوس کو کبھی نہ ڈھانپے۔',
                'دایاں پینل میں آپ کو layer manager ملے گا، جو ہر شامل کردہ واٹرمارک عنصر کی فہرست دکھاتا ہے۔ ہر لیئر اندراج میں لیئر کی قسم (ٹیکسٹ یا تصویر)، اس کا موجودہ نام یا مواد، اور تین فوری کارروائی والے بٹن ہوتے ہیں: visibility toggle (آئیکن eye)، lock toggle تاکہ آپ دوسروں پر کام کرتے ہوئے ایک لیئر کی پوزیشن منجمد کر سکیں، اور delete بٹن۔',
              ],
            },
            {
              title: 'بائیں پیش نظارہ پٹی (ملٹی امیج موڈ)',
              paragraphs: [
                'جب آپ ایک ساتھ کئی تصاویر پر کام کر رہے ہوں - مثلاً پروڈکٹ فوٹوز کا ایک بیچ یا پورا پورٹریٹ سیشن - تو اسکرین کے بالکل بائیں طرف ایک عمودی تھمب نیل پٹی ظاہر ہوتی ہے۔ یہ image queue ہے، جو آپ کی اپلوڈ کی گئی ہر فائل کے چھوٹے پیش نظارے دکھاتی ہے۔ کسی بھی تھمب نیل پر کلک کرنے سے کینوس فوراً اس تصویر پر منتقل ہو جاتا ہے، جس سے آپ لیئر سیٹنگز کھوئے بغیر مختلف کمپوزیشنز میں واٹرمارک کی شکل چیک کر سکتے ہیں۔',
                'یہ پٹی ہر فائل کے لیے KB یا MB میں سائز کی معلومات بھی دکھاتی ہے، ساتھ ہی فائل فارمیٹ ٹیگ (JPG، PNG، WEBP)، تاکہ آپ ایک نظر میں جان سکیں کہ آپ کس چیز پر کام کر رہے ہیں۔',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-steps',
          tocLabel: 'مرحلہ وار',
          title: 'مرحلہ وار: Photremium پر اپنی تصویر میں واٹرمارک کیسے شامل کریں',
          paragraphs: [
            'یہ طریقہ کار براہِ راست اس بات پر مبنی ہے کہ ٹول اندرونی طور پر کیسے کام کرتا ہے - drag-and-drop اپلوڈ سسٹم سے لے کر canvas rendering engine تک جو ڈاؤن لوڈ سے پہلے آپ کا واٹرمارک مستقل طور پر تصویر پر لکھ دیتا ہے۔',
          ],
          steps: [
            {
              heading: 'مرحلہ 1 - اپنی تصویر/تصاویر اپلوڈ کریں',
              paragraphsBefore: [
                'photremium.com/watermark-image پر جائیں۔ آپ اپلوڈ اسکرین پر پہنچیں گے، جہاں صفحے کے درمیان ایک صاف drag-and-drop dropzone موجود ہوتا ہے۔',
                'اپنی تصویر کو ٹول میں لانے کے تین طریقے ہیں:',
              ],
              bullets: [
                'ڈریگ اور ڈراپ۔ اپنے ڈیسک ٹاپ سے ایک یا زیادہ تصویر فائلیں براہِ راست dropzone پر گھسیٹیں۔ ٹول JPEG، PNG، WEBP وغیرہ سمیت ہر عام image format قبول کرتا ہے۔ جب آپ فائلیں ورک اسپیس پر لاتے ہیں تو پورے علاقے کے گرد جامنی border فعال ہو جاتی ہے اور "Drop images to add for watermarking" جیسا بصری prompt ظاہر ہوتا ہے، تاکہ آپ جان سکیں کہ ڈراپ ریکارڈ ہو رہا ہے۔',
                'کلک کر کے براؤز کریں۔ dropzone کے اندر موجود "Choose Files" بٹن پر کلک کریں تاکہ system file picker کھلے۔ آپ Ctrl+Click (Windows) یا Cmd+Click (Mac) سے ایک ساتھ متعدد فائلیں منتخب کر سکتے ہیں۔',
                'clipboard سے پیسٹ کریں۔ اگر آپ نے کسی screenshot، دوسری app، یا web browser سے تصویر copy کی ہے تو watermark صفحے پر ہوتے ہوئے بس Ctrl+V (یا Mac پر Cmd+V) دبائیں، اور تصویر براہِ راست ورک اسپیس میں لوڈ ہو جائے گی۔ یہ اس وقت بھی کام کرتا ہے جب پہلے سے متعدد تصاویر لوڈ ہوں۔',
              ],
              paragraphsAfter: [
                'جیسے ہی پہلی تصویر لوڈ ہوتی ہے، ورک اسپیس اپلوڈ اسکرین سے مکمل تین پینل والے ایڈیٹر میں تبدیل ہو جاتی ہے، اور کینوس آپ کی تصویر کو خودکار طور پر حساب شدہ fit-to-screen zoom level پر دکھاتا ہے۔',
              ],
            },
            {
              heading: 'مرحلہ 2 - ٹیکسٹ واٹرمارک لیئر شامل کریں',
              paragraphsBefore: [
                'دائیں پینل میں جامنی "Add Text" بٹن پر کلک کریں۔ ایک نئی text layer آپ کے کینوس پر default placeholder text "Type here..." کے ساتھ ظاہر ہو گی۔',
                'آپ فوراً لکھنا شروع کر سکتے ہیں۔ ٹیکسٹ کینوس پر live render ہوتا ہے، سفید Arial میں اور ایک default size کے ساتھ جو آپ کی تصویر کے dimensions کے مطابق ہوتا ہے۔ اوپر والا toolbar، جو text layer منتخب ہونے پر ظاہر ہوتا ہے، آپ کو متن کے ہر پہلو کو customize کرنے دیتا ہے:',
              ],
              bullets: [
                'Font family - 12 built-in fonts میں سے منتخب کریں، جن میں Arial، Georgia، Impact، Brush Script MT، Comic Sans MS وغیرہ شامل ہیں',
                'Font size - براہِ راست custom pixel value لکھیں یا increment controls استعمال کریں',
                'Bold، italic، underline - ان styles کا کوئی بھی مجموعہ toggle کریں',
                'Text color - color swatch پر کلک کر کے color picker کھولیں اور کوئی بھی hex color منتخب کریں',
                'Background color - اپنے text کے پیچھے رنگین پس منظر شامل کریں تاکہ label یا badge جیسا look ملے',
                'Stroke (outline) - light اور dark دونوں تصویروں پر زیادہ readability کے لیے stroke width اور color سیٹ کریں',
                'Opacity - 0% (غیر مرئی) سے 100% (مکمل opaque) تک opacity سلائیڈ کریں؛ زیادہ تر واٹرمارکس 30% اور 60% کے درمیان ہوتے ہیں',
                'Alignment - text کو اس کے bounding box کے اندر left، center، یا right align کریں',
                'Rotation - text layer کو کسی بھی زاویے پر rotate کریں، اور 0°، 90°، 180° اور 270° پر magnetic snap points موجود ہیں تاکہ سیدھی پوزیشن تیزی سے مل سکے',
              ],
              paragraphsAfter: [
                'Text کو move کرنے کے لیے اسے کینوس پر کہیں بھی click اور drag کریں۔ انتہائی درست pixel placement کے لیے keyboard کے arrow keys استعمال کریں (10-pixel steps کے لیے Shift دبائیں)۔ Text box کا سائز بدلنے کے لیے selected layer کے گرد ظاہر ہونے والے آٹھ resize handles (corners اور edges) میں سے کسی کو drag کریں۔',
              ],
            },
            {
              heading: 'مرحلہ 3 - تصویر (لوگو) واٹرمارک لیئر شامل کریں',
              paragraphsBefore: [
                'اگر آپ ٹیکسٹ کے بجائے - یا اس کے ساتھ - لوگو، دستخط، یا کوئی بھی تصویر واٹرمارک کے طور پر استعمال کرنا چاہتے ہیں، تو دائیں پینل میں نیلا "Add Image" بٹن دبائیں۔ آپ کا file picker کھل جائے گا تاکہ آپ اپنے device سے واٹرمارک تصویر منتخب کر سکیں۔',
                'ٹول خودکار طور پر واٹرمارک تصویر کو کینوس کی چوڑائی کے تقریباً 30% تک سائز کرتا ہے، اصل aspect ratio برقرار رکھتا ہے، اور اسے کینوس کے درمیان میں رکھ دیتا ہے۔ وہاں سے آپ اسے کسی بھی جگہ drag کر سکتے ہیں، کونے والے handles سے resize کر سکتے ہیں (جو aspect ratio کو محفوظ رکھتے ہیں)، یا منتخب layer کے اوپر دکھائی دینے والے مخصوص rotate handle سے rotate کر سکتے ہیں۔',
                'Image-type watermark layers کے لیے دائیں پینل میں اضافی controls موجود ہیں:',
              ],
              bullets: [
                'Opacity - text layers کی طرح، شفاف PNG logos کے لیے بہترین',
                'Flip horizontal / Flip vertical - ضرورت ہو تو watermark کو mirror کریں',
                'Border width، border color، اور border style - لوگو واٹرمارک کے گرد واضح border شامل کریں',
                'Border radius - لوگو واٹرمارک کے corners کو گول کریں، چاہے یکساں طور پر یا ہر corner پر علیحدہ control کے ساتھ',
                'Rotation - text layers جیسا ہی نرم rotation behavior',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-tips',
          tocLabel: 'پروفیشنل مشورے',
          title: 'بہترین نتائج حاصل کرنے کے لیے پروفیشنل مشورے',
          bullets: [
            'زیادہ پیشہ ورانہ تاثر کے لیے نیم شفاف PNG لوگو استعمال کریں۔ 40-50% opacity کے ساتھ شفاف پس منظر والا لوگو واٹرمارک سادہ ٹیکسٹ کی نسبت کہیں زیادہ بہتر دکھائی دیتا ہے۔ اپنے ڈیزائن ٹول سے لوگو کو alpha transparency کے ساتھ PNG کے طور پر export کریں اور پھر اسے image layer کے طور پر استعمال کریں۔',
            'واٹرمارک کو وہاں رکھیں جہاں اسے crop کرنے سے اس کی اہمیت ختم ہو جائے۔ نیچے دائیں کونا سب سے عام جگہ ہے - اور سب سے آسانی سے crop کیا جا سکتا ہے۔ بہتر تحفظ کے لیے واٹرمارک کو تصویر کے کسی بصری طور پر اہم حصے پر رکھنے پر غور کریں، مثلاً چہرے، پروڈکٹ کی تفصیل، یا مرکزی نکتے کے اوپر۔ Diagonal tile option کو بغیر تصویر کو کافی حد تک خراب کیے ہٹانا اور بھی مشکل ہوتا ہے۔',
            'متعدد layers کے ساتھ کام کرتے وقت lock feature استعمال کریں۔ جب آپ اپنے بنیادی watermark کی پوزیشن سے مطمئن ہو جائیں تو secondary layers شامل کرنے سے پہلے اس layer کو lock کر دیں۔ اس سے دوسرے عناصر پر کام کرتے ہوئے غلطی سے اسے ہلنے سے بچایا جا سکتا ہے۔',
            'اپنی تصویر کے روشن اور تاریک حصوں دونوں پر آزمائش کریں۔ سفید watermark روشن آسمان پر نظر نہیں آتا لیکن گہرے سائے پر بالکل پڑھا جا سکتا ہے۔ پڑھنے کی صلاحیت برقرار رکھنے کے لیے ایک ہلکی سی stroke یا background color شامل کریں، چاہے تصویر کے نیچے کچھ بھی ہو۔',
            'Keyboard shortcuts ہمیشہ وقت بچاتے ہیں۔ Arrow keys منتخب layers کو ایک pixel فی وقت حرکت دیتی ہیں۔ Shift+Arrow دس pixels فی وقت حرکت دیتی ہے۔ Delete key منتخب layer کو فوراً ہٹا دیتی ہے۔ یہ shortcuts placement کی fine-tuning کو drag کرنے سے کہیں زیادہ تیز بناتے ہیں۔',
          ],
        },
        {
          id: 'wm-blog-privacy',
          tocLabel: 'رازداری اور تحفظ',
          title: 'رازداری اور تحفظ: براؤزر پر مبنی پروسیسنگ کیوں اہم ہے',
          paragraphs: [
            'بہت سے تخلیق کار آن لائن ٹولز استعمال کرتے وقت اس بات سے پریشان رہتے ہیں کہ ان کی تصاویر اصل میں کہاں جاتی ہیں۔ Server-based watermarking tools میں آپ کی تصویر فراہم کنندہ کے سرور پر اپلوڈ ہوتی ہے، وہاں پروسیس ہوتی ہے، اور پھر واپس آپ کو بھیجی جاتی ہے۔ اس کا مطلب ہے کہ آپ کا غیر شائع شدہ کام، کلائنٹ کی تصاویر، یا حساس پروڈکٹ تصاویر کسی اور کے infrastructure سے گزرتی ہیں۔',
            'Photremium کا watermark tool ہر چیز کو آپ کے براؤزر میں locally process کرتا ہے۔ آپ کی تصاویر براؤزر کے File API کے ذریعے آپ کے device memory میں load ہوتی ہیں اور کبھی internet پر transmit نہیں ہوتیں۔ Watermark rendering JavaScript میں چلنے والے HTML5 canvas element پر ہوتی ہے، مکمل طور پر آپ کے browser tab کے اندر۔ جب آپ صفحہ بند کرتے ہیں یا "Start Over" پر کلک کرتے ہیں تو تمام image data memory سے release ہو کر discard ہو جاتی ہے۔ آپ کے اپنے device کے باہر کچھ بھی محفوظ نہیں ہوتا۔',
          ],
        },
        {
          id: 'wm-blog-summary',
          tocLabel: 'حتمی خلاصہ',
          title: 'کیوں Photremium کا واٹرمارک ٹول آپ کے باقاعدہ ورک فلو میں جگہ بنانے کا مستحق ہے',
          paragraphs: [
            'آن لائن واٹرمارکنگ ٹولز کی تعداد درجنوں میں ہے۔ ایک ایسا ٹول جسے bookmark کرنا چاہیے اور ایک ایسا جسے بھول جانا چاہیے - ان میں فرق عموماً رفتار، کنٹرول، اور قابلِ اعتماد ہونے کے امتزاج سے ہوتا ہے۔',
            'رفتار اہم ہے کیونکہ واٹرمارک لگانے سے آپ کے post-processing workflow میں خاص وقت نہیں بڑھنا چاہیے۔ Photremium ٹول فوراً لوڈ ہوتا ہے، locally process کرتا ہے، اور چند سیکنڈ میں full resolution پر export کرتا ہے - حتیٰ کہ بڑے batches کے لیے بھی۔ server-side processing کا انتظار نہیں، کوئی queue نہیں، اور ایسا render وقت نہیں جو ایک ساتھ آن لائن صارفین کی تعداد کے ساتھ بڑھے۔',
            'کنٹرول اہم ہے کیونکہ غلط نظر آنے والا watermark، watermark نہ ہونے سے بھی بدتر ہے - یہ آپ کے برانڈ کو غیر پیشہ ورانہ بناتا ہے۔ layer system، toolbar میں property-specific controls، real-time canvas preview، اور keyboard shortcut support مل کر ایک ایسے کنٹرول لیول کی صورت اختیار کرتے ہیں جو واقعی dedicated desktop software کے قریب ہے۔',
            'قابلِ اعتماد ہونا اہم ہے کیونکہ آپ کا غیر شائع شدہ کام قیمتی ہے۔ یہ جاننا کہ آپ کی تصاویر کبھی internet کے ذریعے کسی third-party server تک نہیں جاتیں، آپ کو client photos، unpublished product images، اور حساس creative work کو data handling، server-side breaches، یا cloud provider کی policy تبدیلیوں کی فکر کے بغیر watermark کرنے دیتا ہے۔',
            'چاہے آپ ایک ہی تصویر پر جلدی سے copyright notice لگا رہے ہوں یا 200 تصاویر کے پورے shoot کو client gallery سے پہلے process کر رہے ہوں، Photremium کا Watermark Image ٹول آپ کو یہ کام درست طریقے سے کرنے کے tools دیتا ہے - بالکل مفت، مکمل طور پر نجی، اور اتنی تخلیقی flexibility کے ساتھ کہ watermark ایسا لگے جیسے وہ تصویر کے ساتھ ہی تعلق رکھتا ہو، اس کے اوپر چپکا ہوا نہ ہو۔',
            'photremium.com/watermark-image پر جائیں اور اسے آزمائیں۔ آپ کی پہلی watermarked تصویر لفظی طور پر تیس سیکنڈ کی دوری پر ہے۔',
            'Photremium browser-based image editing اور processing tools کا ایک مجموعہ پیش کرتا ہے۔ تمام tools آپ کے browser میں locally چلتے ہیں - آپ کی تصاویر آپ کے device پر ہی رہتی ہیں۔',
          ],
        },
      ],
    },
  },

  qrGenerator: {
    seo: {
      inputTitle: 'QR کوڈ جنریٹر — مفت QR کوڈ بنائیں اور کسٹمائز کریں | photremium.com',
      inputDesc: 'URLs، متن، WiFi، رابطوں، ای میل اور Google Maps مقامات کے لیے کسٹم QR کوڈ بنائیں۔ رنگ، شکلیں اور لوگو کسٹمائز کریں۔',
      inputKeywords: 'qr کوڈ جنریٹر، qr کوڈ بنائیں، کسٹم qr کوڈ، qr کوڈ میکر، مفت qr کوڈ',
      customizeTitle: 'QR کوڈ کسٹمائز کریں — photremium.com QR کوڈ جنریٹر',
      customizeDesc: 'اپنے QR کوڈ کا انداز، رنگ، فریم اور لوگو کسٹمائز کریں۔ PNG، JPG، SVG، WEBP یا PDF ڈاؤن لوڈ کریں۔',
      customizeKeywords: 'qr کوڈ کسٹمائز، qr کوڈ انداز، qr کوڈ رنگ، qr کوڈ لوگو',
    },
    title: 'QR کوڈ جنریٹر',
    desc: 'URLs، متن، WiFi، رابطے، ای میل اور نقشوں کے لیے QR کوڈ بنائیں، کسٹمائز کریں اور ڈاؤن لوڈ کریں۔',
    generate: 'بنائیں',
    scanQrCode: 'QR کوڈ اسکین کریں',
    tabUrl: 'لنک / URL',
    tabText: 'متن',
    tabWifi: 'WiFi',
    tabContact: 'رابطہ',
    tabEmail: 'Gmail',
    tabMaps: 'Google Maps',
    enterUrl: 'URL درج کریں',
    enterText: 'متن درج کریں',
    networkName: 'نیٹ ورک نام (SSID)',
    password: 'پاس ورڈ',
    encryption: 'خفیہ کاری',
    hiddenNetwork: 'چھپا ہوا نیٹ ورک',
    contactName: 'رابطے کا نام (اختیاری)',
    phoneNumber: 'فون نمبر',
    emailAddress: 'ای میل پتہ',
    subject: 'موضوع (اختیاری)',
    body: 'مواد (اختیاری)',
    searchLocation: 'مقام تلاش کریں',
    urlPlaceholder: 'https://example.com',
    textPlaceholder: 'یہاں متن درج کریں…',
    wifiNamePlaceholder: 'میرا WiFi',
    passwordPlaceholder: 'پاس ورڈ',
    contactPlaceholder: 'احمد علی',
    phonePlaceholder: '+92 XXX XXXXXXX',
    emailPlaceholder: 'example@gmail.com',
    subjectPlaceholder: 'موضوع',
    bodyPlaceholder: 'ای میل مواد…',
    locationPlaceholder: 'شہر، پتہ، مقام تلاش کریں…',
    wpaWpa2: 'WPA / WPA2',
    wep: 'WEP',
    none: 'کوئی نہیں',
    characters: 'حروف',
    generateCustomize: 'بنائیں اور کسٹمائز کریں',
    editQrData: 'QR ڈیٹا ترمیم کریں',
    styleShape: 'انداز اور شکل',
    colorTab: 'رنگ',
    framesTab: 'فریم',
    logoTab: 'لوگو',
    templatesTab: 'ٹیمپلیٹس',
    fileFormatTab: 'فائل فارمیٹ',
    fgColor: 'پیش منظر رنگ',
    bgColor: 'پس منظر رنگ',
    enableGradient: 'گریڈینٹ فعال کریں',
    gradientType: 'گریڈینٹ قسم',
    linear: 'خطی',
    radial: 'شعاعی',
    selectFrame: 'فریم منتخب کریں',
    selectLogo: 'لوگو منتخب کریں',
    uploadCustomLogo: 'یا کسٹم لوگو اپلوڈ کریں',
    uploadImage: 'تصویر اپلوڈ کریں',
    downloadFormat: 'ڈاؤن لوڈ فارمیٹ',
    preview: 'پیش نظارہ',
    downloadFormatBtn: '{format} ڈاؤن لوڈ کریں',
    pngDesc: 'بغیر نقصان، شفافیت سپورٹ',
    jpgDesc: 'مقبول/عالمی فائل فارمیٹ',
    webpDesc: 'جدید فارمیٹ، بہترین کوالٹی/سائز',
    svgDesc: 'قابلِ توسیع ویکٹر گرافک',
    pdfDesc: 'پرنٹ کے لیے تیار دستاویز',
    lat: 'عرض البلد:',
    lng: 'طول البلد:',
    qrCode: 'QR کوڈ',
    scanMe: 'اسکین کریں',
    scanHere: 'یہاں اسکین کریں',
    blog: {
      card1: {
        title: '۱۔ کیو آر کوڈ کیا ہے؟',
        intro1: 'کیو آر کوڈ کا پورا نام "کوئیک ریسپانس کوڈ" ہے۔ کیونکہ اس میں موجود معلومات بہت تیزی سے ڈی کوڈ ہوتی ہیں، اسی لیے اسے کوئیک ریسپانس (کیو آر) کوڈ کہا جاتا ہے۔',
        intro2: 'کیو آر کوڈ ایک دو بُعدی ڈیجیٹل کوڈ ہے جسے صرف مشینیں پڑھ سکتی ہیں۔ انسان براہِ راست اس کا ڈیٹا نہیں پڑھ سکتا۔ اس میں متن، رابطہ نمبر، لنکس اور گوگل میپس کے مقامات جیسی معلومات محفوظ کی جا سکتی ہیں۔',
        inventionTitle: 'کیو آر کوڈ کی ایجاد کیسے ہوئی:',
        inventionText: 'کیو آر کوڈ ۱۹۹۴ میں ایجاد ہوا۔ ماساہیرو ہارا اور ان کی ٹیم جاپانی کمپنی ڈینسو ویو میں کام کر رہی تھی جو ٹویوٹا کے لیے پارٹس بناتی تھی۔ وہ ایسا کوڈ چاہتے تھے جو روایتی بارکوڈ سے کہیں زیادہ معلومات سنبھال سکے، اسی لیے انہوں نے کیو آر کوڈ ایجاد کیا۔',
        keyFeaturesTitle: 'کیو آر کوڈ کی بنیادی خصوصیات',
        keyFeatures: [
          {
            title: 'کیو آر کیسے کام کرتا ہے',
            text: 'آپ متن یا لنک درج کرتے ہیں تو جنریٹر معلومات کے مطابق مربع خانے بناتا ہے۔ ہر خانہ ایک بِٹ کی نمائندگی کرتا ہے اور ہر بِٹ ایک حرف محفوظ کرتا ہے۔',
          },
          {
            title: 'کیو آر کوڈ کی ساخت',
            text: 'کیو آر کوڈ میں سمت شناخت کے لیے تین بڑے مربع خانے ہوتے ہیں، اور معلومات محفوظ کرنے کے لیے چھوٹے مربع ماڈیولز ہوتے ہیں۔',
          },
          {
            title: 'کیو آر کوڈ کی ڈیٹا گنجائش',
            text: 'عموماً کیو آر کوڈ بارکوڈ کے مقابلے میں زیادہ معلومات محفوظ کرتا ہے۔ یہ بارکوڈ کا دو بُعدی جدید ورژن ہے اور عام طور پر تقریباً ۲۰۰ حروف محفوظ کر لیتا ہے۔ ۴۰۰ حروف تک محفوظ کرنا ممکن ہے مگر اسکین کرنا مشکل ہو سکتا ہے، اس سے زیادہ پر کوڈ بہت پیچیدہ ہو جاتا ہے۔',
          },
          {
            title: 'کیو آر کوڈ میں خرابی کی شناخت',
            text: 'اگر کوڈ کے کچھ حصے خراش زدہ ہوں تب بھی اسے اکثر اسکین کیا جا سکتا ہے۔ کیو آر کوڈ غلطیوں کی شناخت کے لیے ریڈ-سولومون تکنیک استعمال کرتا ہے اور پھر انہیں درست کرتا ہے۔',
          },
        ],
        errorTitle: 'کیو آر کوڈ کے ایرر کریکشن درجے:',
        errorIntro: 'مختلف حالات میں مختلف ایرر شناخت اور درستگی کی تکنیکیں یوں استعمال ہوتی ہیں:',
        errorHeaders: {
          level: 'درجہ',
          recovery: 'ریکوری صلاحیت',
          bestUse: 'بہترین استعمال',
        },
        errorRows: [
          {
            level: 'کم (ایل)',
            recovery: '~۷%',
            useCases: [
              'یہ درجۂ درستگی تب استعمال ہوتا ہے جب کیو آر کوڈ ڈیجیٹل اسکرین یا ویب صفحے پر صاف ماحول میں دکھایا جائے۔',
              'جب کیو آر کوڈ چھوٹی معلومات جیسے جی میل، رابطہ نمبر یا مختصر متن کے لیے ہو۔',
            ],
          },
          {
            level: 'درمیانہ (ایم)',
            recovery: '~۱۵%',
            useCases: [
              'فلائرز اور پوسٹرز کے لیے جو صاف ماحول میں ہوں اور جہاں نقصان کا امکان کم ہو۔',
            ],
          },
          {
            level: 'کوارٹائل (کیو)',
            recovery: '~۲۵%',
            useCases: [
              'جب کیو آر کوڈ فیکٹری یا آؤٹ ڈور جیسی سخت جگہ پر نصب کیا جائے۔',
              'جب درمیان میں چھوٹا لوگو رکھنا ہو جو کچھ بِٹس ڈھانپ دے تو یہ درجہ مفید ہوتا ہے۔',
            ],
          },
          {
            level: 'زیادہ (ایچ)',
            recovery: '~۳۰%',
            useCases: [
              'جب کیو آر کوڈ کو شدید نقصان پہنچنے کا امکان ہو۔',
              'جب بڑا لوگو مرکز کو ڈھانپتا ہو۔',
              'یا جب بہت زیادہ اسٹائلنگ درکار ہو۔',
            ],
          },
        ],
      },
      card2: {
        title: '۲۔ ہمارا کیو آر کوڈ جنریٹر کیوں چنیں؟',
        intro: 'ہمارا کیو آر کوڈ جنریٹر کوڈ بنانا بہت تیز، محفوظ اور آسان بناتا ہے۔ آپ رنگ، انداز اور لوگو سب کچھ اپنی برانڈنگ کے مطابق کرسکتے ہیں، اور یہ سب ہمیشہ مفت ہے۔',
        strengths: [
          {
            title: 'پروفیشنل کسٹمائزیشن:',
            text: 'جتنے چاہیں کیو آر کوڈ بنائیں اور کسٹمائز کریں، کوئی قیمت نہیں۔ گریڈینٹ رنگ، مختلف شکلیں، کسٹم لوگوز اور بہت سے فیچرز دستیاب ہیں۔',
          },
          {
            title: 'متعدد فارمیٹس کی سہولت:',
            text: 'ڈاؤن لوڈ سے پہلے اپنی پسند کا فارمیٹ چنیں۔ فی الحال ہم یہ فراہم کرتے ہیں:',
          },
          {
            title: 'تیار شدہ ٹیمپلیٹس:',
            text: 'پہلے سے بنے گریڈینٹ رنگ اور فریم استعمال کریں تاکہ آپ کا کیو آر کوڈ فوری طور پر پروفیشنل لگے۔',
          },
          {
            title: 'کسٹم لوگو سپورٹ:',
            text: 'اپنا برانڈ لوگو اپ لوڈ کریں، یہ خودکار طور پر مرکز میں فِٹ ہو جاتا ہے۔ یا بلٹ ان لائبریری سے انتخاب کریں۔',
          },
          {
            title: 'براہِ راست پیش نظارہ:',
            text: 'کسٹمائزیشن کے دوران تمام تبدیلیاں لائیو پیش نظارہ پینل میں فوراً دکھائی دیتی ہیں۔',
          },
          {
            title: 'اسکین اشارہ:',
            text: 'اگر منتخب رنگ اسکین میں رکاوٹ بنیں تو انتباہات اور اشارے آپ کو رہنمائی دیتے ہیں۔',
          },
        ],
        formatHeaders: {
          srNo: 'نمبر',
          formats: 'فارمیٹس',
          description: 'تفصیل',
        },
        formatRows: [
          { no: '۱', format: 'پی این جی', description: 'لاس لیس، شفافیت کی سہولت' },
          { no: '۲', format: 'جے پی جی', description: 'مقبول اور عام فائل فارمیٹ' },
          { no: '۳', format: 'ویب پی', description: 'جدید، بہترین کوالٹی بمقابلہ سائز' },
          { no: '۴', format: 'ایس وی جی', description: 'آزادانہ پیمانے والی ویکٹر گرافک' },
          { no: '۵', format: 'پی ڈی ایف', description: 'پرنٹ کے لیے تیار دستاویز' },
        ],
      },
      card3: {
        title: '۳۔ مرحلہ وار رہنمائی:',
        step1Intro: 'سب سے پہلے وہ کیٹیگری چنیں جس کے لیے آپ کیو آر کوڈ بنانا چاہتے ہیں، چاہے رابطہ، نقشہ، لنک یا متن۔ فی الحال یہ کیٹیگریز دستیاب ہیں:',
        categories: ['لنک / یو آر ایل', 'متن', 'وائی فائی', 'رابطہ', 'جی میل', 'گوگل میپس'],
        step2: 'کیٹیگری منتخب کرنے کے بعد متعلقہ خانے میں اپنی معلومات پیسٹ کریں۔',
        step3Intro: 'پھر "بنائیں اور کسٹمائز کریں" پر کلک کریں تاکہ کسٹمائزیشن پینل کھلے۔ اس پینل میں سب نیویگیشن بار میں یہ اختیارات ملیں گے:',
        options: [
          {
            title: 'انداز اور شکل:',
            text: 'یہاں آپ مربع خانوں کی شکلیں بدل سکتے ہیں: گول کونے، نقطے، افقی یا عمودی بار، چھوٹے مربع وغیرہ۔',
          },
          {
            title: 'رنگ:',
            text: 'پس منظر اور پیش منظر کے اپنے رنگ منتخب کریں۔ گریڈینٹ فعال کریں، بلٹ اِن لائبریری سے کوئی بھی گریڈینٹ لگائیں یا اپنا بنائیں، لکیری زاویہ بدلیں یا شعاعی گریڈینٹ استعمال کریں۔',
          },
          {
            title: 'فریمز:',
            text: 'اپنے کیو آر کوڈ کے لیے موزوں فریم چنیں۔ تمام فریمز خودکار طور پر فٹ ہو جاتے ہیں۔',
          },
          {
            title: 'لوگو:',
            text: 'فریم کے بعد لوگو منتخب کریں جو خودکار طور پر مرکز میں بیٹھ جاتا ہے۔ اپنا کسٹم لوگو بھی اپ لوڈ کر سکتے ہیں۔',
          },
          {
            title: 'ٹیمپلیٹس:',
            text: 'اگر آپ علیحدہ انتخاب نہیں کرنا چاہتے تو پری میڈ ٹیمپلیٹس ایک کلک میں لاگو کریں۔',
          },
          {
            title: 'فائل فارمیٹ:',
            text: 'آخر میں وہ فائل قسم منتخب کریں جس میں آپ کیو آر کوڈ ڈاؤن لوڈ کرنا چاہتے ہیں۔ پی این جی، ویب پی، ایس وی جی اور پی ڈی ایف جیسی عام فارمیٹس دستیاب ہیں۔',
          },
          {
            title: 'کیو آر ڈیٹا میں ترمیم:',
            text: 'آپ اپنی منتخب کردہ کسٹمائزیشن برقرار رکھتے ہوئے کیو آر ڈیٹا بھی تبدیل کر سکتے ہیں۔',
          },
        ],
        finalStep: 'پھر ڈاؤن لوڈ بٹن دبائیں، اور کیو آر کوڈ بالکل آپ کی کسٹمائزیشن اور منتخب فارمیٹ کے مطابق فوراً اور مفت ڈاؤن لوڈ ہو جائے گا۔',
      },
      card4: {
        title: '۴۔ فوائد:',
        intro: 'کیو آر کوڈ جسمانی دنیا کو ڈیجیٹل تجربے سے جوڑتا ہے۔ لنک، رابطہ یا لوکیشن تیز ترین انداز میں شیئر کرنے کا طریقہ ہے۔ بس اسکین کریں اور معلومات فوراً حاصل کریں، اسی لیے یہ کاروبار اور ڈیجیٹل دنیا میں بہت مقبول ہے۔',
        benefits: [
          {
            title: 'تاحیات سہولت:',
            text: 'کیو آر کوڈز بغیر میعاد ختم ہونے کے ہمیشہ کام کرتے ہیں۔ اسکین کرتے ہی محفوظ معلومات فوراً ملتی ہیں، کیونکہ یہ ہدایات ہارڈ کوڈڈ ہوتی ہیں۔',
          },
          {
            title: 'آف لائن سہولت:',
            text: 'آپ آف لائن بھی کیو آر کوڈ اسکین کر سکتے ہیں۔ موبائل کیمرہ پیٹرن پڑھ کر محفوظ معلومات دکھا دیتا ہے۔',
          },
          {
            title: 'صفر لاگت:',
            text: 'چونکہ ان کوڈز کو سرور ری ڈائریکشن یا اضافی وسائل نہیں چاہئیں، یہ ہمیشہ کے لیے مفت رہتے ہیں۔',
          },
        ],
      },
    },
  },

  qrScanner: {
    seo: {
      title: 'QR کوڈ اسکینر — کیمرے یا تصویر سے QR کوڈ اسکین کریں | photremium.com',
      desc: 'کیمرے سے یا تصویر اپلوڈ کر کے QR کوڈ فوری اسکین کریں۔ URLs، متن، WiFi، رابطے اور مزید دریافت کریں۔ مفت، تیز، نجی۔',
      keywords: 'qr کوڈ اسکینر، qr کوڈ اسکین کریں، qr ریڈر، qr کوڈ ریڈر آن لائن، کیمرا qr اسکینر',
    },
    title: 'QR کوڈ اسکینر',
    desc: 'کیمرے سے یا تصویر اپلوڈ کر کے QR کوڈ فوری اسکین کریں۔ تیز، نجی اور محفوظ۔',
    generateQrCode: 'QR کوڈ بنائیں',
    scan: 'اسکین کریں',
    cameraScanner: 'کیمرا اسکینر',
    uploadImage: 'تصویر اپلوڈ کریں',
    pointCamera: 'کیمرے کو QR کوڈ کی طرف کریں',
    startCamera: 'کیمرا شروع کریں',
    loading: 'لوڈ ہو رہا ہے…',
    dropQrImage: 'QR کوڈ تصویر یہاں چھوڑیں',
    toScan: 'اسکین کرنے کے لیے',
    supportedFormats: 'JPG، PNG، GIF، WEBP سپورٹڈ',
    ctrlVPaste: 'Ctrl+V پیسٹ کرنے کے لیے',
    scanFromGallery: 'گیلری سے اسکین کریں',
    accessingCamera: 'کیمرا رسائی حاصل ہو رہی ہے…',
    cameraDenied: 'کیمرا رسائی سے انکار کیا گیا۔ براہ کرم کیمرا اجازت دیں اور دوبارہ کوشش کریں۔',
    noCamera: 'اس ڈیوائس پر کوئی کیمرا نہیں ملا۔',
    cameraError: 'کیمرا تک رسائی نہیں ہو سکی۔ دوبارہ کوشش کریں۔',
    tryAgain: 'دوبارہ کوشش کریں',
    switchCamera: 'کیمرا بدلیں',
    stop: 'روکیں',
    noQrFound: 'کوئی QR کوڈ نہیں ملا',
    couldNotRead: 'تصویر پڑھنے میں ناکامی',
    scannerFailed: 'اسکینر لوڈ نہیں ہو سکا',
    noQrFoundDesc: 'تصویر میں کوئی QR کوڈ نہیں پایا گیا۔ کوئی اور تصویر آزمائیں یا کیمرا اسکینر استعمال کریں۔',
    qrScanned: 'QR کوڈ اسکین ہو گیا!',
    openLink: 'لنک کھولیں',
    copied: 'کاپی ہو گیا!',
    copy: 'کاپی کریں',
    share: 'شیئر کریں',
    scanAgain: 'دوبارہ اسکین کریں',
    network: 'نیٹ ورک',
    password: 'پاس ورڈ',
    security: 'سیکیورٹی',
    unknown: 'نامعلوم',
    blog: {
      tocTitle: 'مواد',
      sections: [
        {
          id: 'why-use-qr-code-scanner',
          title: '1. QR کوڈ اسکینر کیوں استعمال کریں؟',
          paragraphs: [
            'QR کوڈ اسکینر بنیادی طور پر ایک موبائل کیمرا ہے جو QR کوڈ میں محفوظ معلومات کو ڈیکوڈ کرتا ہے۔ آپ کو صرف کیمرے کو QR کوڈ کی طرف کرنا ہوتا ہے؛ QR کوڈ کی سمت کچھ بھی ہو، یہ مخصوص پیٹرن پڑھتا ہے، غلطیاں شناخت کرتا ہے، ضرورت پڑنے پر غلطیاں درست کرتا ہے، اور اس میں موجود معلومات دکھاتا ہے۔',
          ],
          listTitle: 'QR کوڈ اسکینرز کی اقسام:',
          bullets: [
            'ویب بیسڈ QR کوڈ اسکینر: آپ اپنے براؤزر سے سپورٹڈ آن لائن اسکینرز کے ذریعے QR کوڈ اسکین کر سکتے ہیں۔ آپ کیمرے کے ذریعے یا تصویر اپلوڈ کر کے معلومات حاصل کر سکتے ہیں۔ آٹو ری ڈائریکشن اور دیگر ایڈوانس فیچرز کے لیے آپ https://photremium.com پر جا سکتے ہیں۔',
            'موبائل کیمرے: کچھ جدید موبائلز میں اصل کیمرا ایپ کے اندر ہی QR کوڈ اسکینر موجود ہوتا ہے۔ یہ صرف سادہ کیمرہ اسکین کے ذریعے معلومات حاصل اور ڈیکوڈ کر لیتے ہیں۔',
            'ایپس: کچھ ایپس خاص طور پر QR کوڈ اسکین کرنے کے لیے بنائی گئی ہیں۔ تاہم، ایڈوانس ری ڈائریکشن اور کئی دیگر فیچرز کے لیے آپ یہ ایپ اس لنک سے مفت انسٹال کر سکتے ہیں: https://photremium.com۔',
            'ہارڈویئر ڈیوائسز: کچھ ہارڈویئر ڈیوائسز بھی QR کوڈ اسکین کرنے کے لیے بنائے جاتے ہیں۔ یہ ڈیوائسز بڑے شاپنگ مالز میں آئٹمز کی بلنگ کے لیے وسیع پیمانے پر استعمال ہوتے ہیں۔',
          ],
        },
        {
          id: 'why-choose-our-qr-code-scanner',
          title: '2. ہمارا QR کوڈ اسکینر کیوں منتخب کریں؟',
          paragraphs: [
            'آپ کئی ایڈوانس فیچرز استعمال کر سکتے ہیں، جن میں ری ڈائریکشن سے لے کر QR کوڈ سے ڈیکوڈ شدہ مواد کو کاپی کرنا شامل ہے۔ آپ ہمارے QR کوڈ اسکینر میں مزید کئی دلچسپ فیچرز بھی دیکھ سکتے ہیں، جیسے:',
          ],
          bullets: [
            'تیز رفتار: ہمارا QR کوڈ اسکینر ڈیکوڈنگ کو انتہائی تیز بناتا ہے۔ آپ کو صرف QR کوڈ اسکین کرنا ہوتا ہے اور ہمارا ٹول فوری طور پر معلومات دیتا ہے، ساتھ ہی ٹیکسٹ/لنک کاپی کرنے، لنک ملنے پر کھولنے، یا رابطہ ملنے پر خودکار محفوظ کرنے جیسے ایڈوانس آپشنز دیتا ہے۔',
            'انسٹالیشن کی ضرورت نہیں: ہمارے QR کوڈ اسکینر کے لیے آپ کو کوئی الگ ایپ انسٹال کرنے کی ضرورت نہیں۔ آپ یہ ٹول اپنے مقامی براؤزر میں مفت استعمال کر سکتے ہیں۔',
            'کراس پلیٹ فارم رسائی: آپ اسے کسی بھی ڈیوائس پر استعمال کر سکتے ہیں۔ OS ورژن یا کسی اور شرط کی فکر نہیں۔ یہ تمام ورژنز اور تمام ڈیوائسز پر سپورٹڈ ہے۔',
            'تمام فارمیٹس سپورٹڈ: وہ تمام ڈیٹا فارمیٹس جو QR کوڈ میں محفوظ ہو سکتے ہیں، جیسے سادہ متن، WiFi، URLs، روابط، Gmail اور Google Maps وغیرہ، ہمارے ٹول میں سپورٹڈ ہیں۔',
          ],
        },
        {
          id: 'step-by-step-guide',
          title: '3. مرحلہ وار رہنمائی:',
          steps: [
            {
              heading: '1. سب سے پہلے، QR کوڈ اسکین کرنے کا طریقہ منتخب کریں۔ اس کے دو طریقے ہیں:',
              subSteps: [
                {
                  heading: 'i. کیمرا طریقہ',
                  paragraphs: [
                    'آپ QR کوڈ کو اپنے ڈیوائس کے کیمرے سے اسکین کر سکتے ہیں چاہے آپ لیپ ٹاپ، PC، یا کوئی بھی ایسا ڈیوائس استعمال کر رہے ہوں جس میں سادہ کیمرا ہو۔ “کیمرا شروع کریں” بٹن پر کلک کرتے ہی پرمیشن ریکویسٹ آئے گی؛ اس سائٹ کو QR اسکیننگ کے لیے کیمرا استعمال کرنے کی اجازت دیں۔ اگر آپ نے غلطی سے انکار کر دیا ہو یا پرمیشن ریکویسٹ نظر نہ آئے، تو آپ درج ذیل مراحل سے دستی طور پر کیمرا رسائی دے سکتے ہیں:',
                  ],
                  notes: [
                    '➔ Chrome (Android / Desktop) کے لیے:',
                    '1. تین نقطوں پر کلک کریں',
                    '2. Settings میں جائیں',
                    '3. (Android میں یہ مرحلہ چھوڑ دیں) Privacy and Security',
                    '4. Site Settings پر کلک کریں',
                    '5. پھر permissions سیکشن میں Camera پر کلک کریں',
                    '6. ہماری سائٹ کا URL تلاش کریں: https://photremium.com/qr-code-scanner',
                    '7. ڈراپ ڈاؤن سے کیمرا Allow کریں۔',
                    '➔ Safari (iPhone / iOS) کے لیے:',
                    '1. ایڈریس بار میں AA یا Website Settings آئیکن پر ٹیپ کریں۔',
                    '2. Website Settings منتخب کریں۔',
                    '3. Camera پر ٹیپ کریں اور Allow منتخب کریں۔',
                    '4. اگر پھر بھی بلاک ہو: iPhone Settings > Safari > Camera میں جا کر اسے Ask یا Allow پر سیٹ کریں۔',
                  ],
                },
                {
                  heading: 'ii. گیلری طریقہ',
                  paragraphs: [
                    'آپ QR کوڈ کی تصویر اپلوڈ کر کے معلومات حاصل کر سکتے ہیں۔ “گیلری سے اسکین کریں” بٹن پر کلک کریں، تو فائل ایکسپلورر کھل جائے گا۔ پھر QR کوڈ کی تصویر منتخب کریں۔ تمام تصویری فارمیٹس سپورٹڈ ہیں جیسے .jpg، .jpeg، .png، .gif، .webp، .svg، .avif، .heic، .heif، .jxl، .bmp، .ico، .tiff، .tif، .jfif، .jpe، .pjpeg، .pjp، .apng، .svgz، اور .xbm وغیرہ۔',
                  ],
                },
              ],
            },
            {
              heading: '2. جب آپ QR کوڈ منتخب کرتے ہیں تو تمام معلومات ظاہر ہو جاتی ہیں؛ جس سے آپ کاپی، شیئر، یا لنک ملنے پر اسے کھول سکتے ہیں۔ اگر چاہیں تو دوبارہ اسکین بھی کر سکتے ہیں۔',
            },
          ],
        },
        {
          id: 'benefits-of-qr-code-scanner',
          title: 'QR کوڈ اسکینر کے فوائد:.',
          paragraphs: [
            'QR کوڈ اسکینر اس ڈیجیٹل دنیا میں کئی فوائد فراہم کرتا ہے۔ یہ ادائیگی، تصدیق، اور معلومات تک رسائی کو آسان اور تیز بناتا ہے، حتیٰ کہ آف لائن موڈ میں بھی۔',
          ],
          bullets: [
            'معلومات تک فوری رسائی: QR کوڈ اسکین کرنے سے ملی سیکنڈز میں معلومات مل جاتی ہیں۔ یہ پیٹرنز ڈیکوڈ کرتا ہے، غلطیاں شناخت کرتا ہے، اور فوری طور پر درست کرتا ہے، جس سے صارف کو انتہائی تیز تجربہ ملتا ہے۔',
            'بہتر مواصلت: ترقی کے اس دور میں بینک تفصیلات اور پراڈکٹ تفصیلات جیسی چھوٹی معلومات کے لیے تیز اور محفوظ مواصلت کی ضرورت ہے۔ QR کوڈ اسکینر یہ مسئلہ حل کرتا ہے کیونکہ ادائیگیاں QR کوڈ اسکین کر کے کی جاتی ہیں۔ اسی طرح، لیپ ٹاپ پر نیا اکاؤنٹ بناتے وقت Google موبائل فون کی توثیق بھی QR کے ذریعے کرتا ہے۔',
            'E-Tickets: بس اسٹیشن، ریلوے اسٹیشن یا ایئرپورٹس پر آپ لمبی قطار میں انتظار کیے بغیر آسانی سے ٹکٹس ویریفائی کر سکتے ہیں۔ مزید یہ کہ ایئرپورٹس پر متعدد مقامات پر QR اسکینرز نصب ہوتے ہیں تاکہ قطاریں کم ہوں۔ اس سے ملازمین کی ضرورت بھی کم ہوتی ہے اور ایئرلائن کا بجٹ بچتا ہے۔',
            'پراڈکٹ کی تصدیق: جدید اور اعلیٰ برانڈز اپنی مصنوعات پر QR کوڈ لگاتے ہیں۔ صارف اس QR کوڈ کو اسکین کر کے پراڈکٹ کی اصلیت چیک کر سکتا ہے کہ آیا وہ اصل ہے یا نہیں۔',
          ],
        },
      ],
    },
  },

  faceBlur: {
    seo: {
      uploadTitle: 'چہرہ بلر ٹول — آن لائن تصاویر میں چہرے بلر کریں | photremium.com',
      uploadDesc: 'AI چہرہ شناسی کے ساتھ تصاویر میں چہرے خودبخود بلر کریں۔ بلر کی شدت، شکل منتخب کریں یا ایموجی اوورلے شامل کریں۔ 100% مفت، تیز اور نجی۔',
      uploadKeywords: 'چہرہ بلر، چہرے بلر کریں، چہرہ شناسی، رازداری ٹول، چہرہ بلر آن لائن مفت',
      workspaceTitle: 'چہرہ بلر ٹول — آن لائن تصاویر میں چہرے بلر کریں | photremium.com',
      workspaceDesc: 'تصاویر میں چہرے خودبخود بلر کریں۔ 100% مفت، تیز اور نجی۔',
      workspaceKeywords: 'چہرہ بلر، چہرے بلر کریں، چہرہ شناسی',
    },
    title: 'چہرہ بلر کریں',
    desc: 'زیادہ رازداری کے لیے تصاویر میں چہرے خودبخود پہچانیں اور بلر کریں۔',
    toBlurFaces: 'چہرے بلر کریں',
    autoDetection: 'خودکار پہچان',
    autoDetectionDesc: 'AI چہرہ شناسی فوری طور پر تمام چہرے ڈھونڈتی ہے',
    customBlur: 'کسٹم بلر',
    customBlurDesc: 'بلر کی شدت، شکل اور انداز کسٹمائز کریں',
    private100: '100% نجی',
    private100Desc: 'تمام پروسیسنگ آپ کے براؤزر میں مقامی طور پر ہوتی ہے',
    blurTools: 'بلر ٹولز',
    faces: 'چہرے',
    faceDetection: 'چہرہ شناسی',
    detecting: 'پہچان ہو رہی ہے...',
    autoDetectFaces: 'چہرے خودبخود پہچانیں',
    exitManualMode: 'دستی موڈ سے باہر',
    manualSelect: 'دستی انتخاب',
    nFaceRegions: '{n} چہرہ علاقہ(ے) ملے',
    noFacesDetected: 'کوئی چہرہ نہیں پہچانا — دستی موڈ استعمال کریں',
    manualHint: 'بلر کرنے کے لیے علاقے پر مستطیل کھینچنے کے لیے کلک کریں اور گھسیٹیں۔',
    blurType: 'بلر کی قسم',
    blur: 'بلر',
    emoji: 'ایموجی',
    blurIntensity: 'بلر شدت',
    strength: 'طاقت',
    blurShape: 'بلر شکل',
    rectangle: 'مستطیل',
    ellipse: 'بیضوی',
    circle: 'دائرہ',
    chooseEmoji: 'ایموجی منتخب کریں',
    blurRegionsN: 'بلر علاقے ({n})',
    faceN: 'چہرہ {n}',
    manualRegionN: 'دستی علاقہ {n}',
    manualN: 'دستی {n}',
    clearAllRegions: 'تمام علاقے صاف کریں',
    processingDots: 'پروسیسنگ...',
    downloadBlurred: 'بلر تصویر ڈاؤن لوڈ کریں',
    downloadNImages: '{n} تصاویر ڈاؤن لوڈ کریں',
    downloadDialogTitle: 'تمام تصاویر ایڈٹ نہیں ہوئیں',
    downloadDialogText: 'آپ نے {total} میں سے {edited} تصاویر ایڈٹ کیں۔',
    downloadAll: 'سب ڈاؤن لوڈ کریں',
    removeRegion: 'علاقہ ہٹائیں',
    region: 'علاقہ',
    notAllEdited: 'تمام تصاویر ایڈٹ نہیں ہوئیں',
    editedXofY: 'آپ نے {total} میں سے {edited} تصاویر ایڈٹ کیں۔',
    nextImage: 'اگلی تصویر',
  },

  faqData: {
    imageConverter: [
      { q: 'کنورژن کے لیے کون سے امیج فارمیٹس سپورٹ ہیں؟', a: 'ہم JPG، PNG، WEBP، SVG، GIF، BMP، ICO اور TIFF کو سپورٹ کرتے ہیں۔ آپ ان فارمیٹس کے درمیان اپنے براؤزر میں فوری طور پر کنورٹ کر سکتے ہیں۔' },
      { q: 'کیا کنورژن کے دوران امیج کا معیار متاثر ہوگا؟', a: 'PNG جیسے لاس لیس فارمیٹس کے لیے معیار مکمل طور پر محفوظ رہتا ہے۔ JPG اور WEBP کے لیے ہم بہتر انکوڈنگ سیٹنگز استعمال کرتے ہیں۔' },
      { q: 'کیا فائل سائز یا تعداد کی کوئی حد ہے؟', a: 'کوئی سخت حد نہیں ہے۔ آپ ایک ساتھ متعدد تصاویر اپلوڈ کر کے بیچ کنورٹ کر سکتے ہیں۔ سب کچھ آپ کے براؤزر میں مقامی طور پر چلتا ہے۔' },
      { q: 'کیا میرا ڈیٹا محفوظ ہے؟ کیا تصاویر کسی سرور پر اپلوڈ ہوتی ہیں؟', a: 'بالکل۔ تمام پروسیسنگ 100% آپ کے براؤزر میں ہوتی ہے۔ آپ کی تصاویر کبھی آپ کے ڈیوائس سے باہر نہیں جاتیں۔' },
      { q: 'کیا میں شفاف PNG کو JPG میں کنورٹ کر سکتا ہوں؟', a: 'ہاں۔ چونکہ JPG شفافیت سپورٹ نہیں کرتا، اس لیے شفاف حصے بطور ڈیفالٹ سفید پس منظر سے بھر جاتے ہیں۔' },
    ],
    imageCompressor: [
      { q: 'کیا تصویر کو کمپریس کرنے سے کوالٹی کم ہو جاتی ہے؟', a: 'نہیں، تصویر کی کوالٹی اس وقت تک متاثر نہیں ہوتی جب تک آپ تجویز کردہ حد سے زیادہ کمپریشن نہ کریں۔ کوالٹی کے اشارے آپ کی رہنمائی کرتے ہیں: i. 1 سے 40% کمپریشن: سبز اشارہ اور “اچھی کوالٹی” کا پیغام۔ ii. 41 سے 60% کمپریشن: پیلا اشارہ اور “نارمل کوالٹی” کا پیغام۔ بہترین نتائج کے لیے یہ حد تجویز کی جاتی ہے۔ iii. 61 سے 100% کمپریشن: نظام سرخ وارننگ کے ساتھ “کمزور کوالٹی” دکھاتا ہے۔ اس حد میں معیار میں واضح کمی آ سکتی ہے۔' },
      { q: 'کمپریشن کے لیے کون سے امیج فارمیٹس سپورٹ ہوتے ہیں؟', a: 'ہمارا امیج کمپریسر درج ذیل تمام فارمیٹس کو سپورٹ کرتا ہے:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'کیا میں ایک وقت میں کئی تصاویر کمپریس کر سکتا ہوں؟', a: 'جی ہاں، بالکل۔ اگر آپ کا سسٹم سپورٹ کرے تو آپ ایک ساتھ کئی تصاویر (حتیٰ کہ 100+) کمپریس کر سکتے ہیں۔ چونکہ کمپریشن سسٹم کے وسائل استعمال کرتی ہے، اس لیے بڑی تعداد کے لیے بہتر کارکردگی والا ڈیوائس مفید رہتا ہے۔ کمزور ڈیوائس پر آپ تصاویر کو بیچز میں کمپریس کر سکتے ہیں، اور ٹول پھر بھی مکمل طور پر مفت رہتا ہے۔' },
      { q: 'کیا آپ ہماری تصاویر اپنے سرورز پر اپلوڈ یا محفوظ کرتے ہیں؟', a: 'نہیں۔ ہم آپ کی تصاویر کو کبھی اپنے سرورز پر اپلوڈ یا محفوظ نہیں کرتے۔ تمام کمپریشن آپ کے براؤزر میں مقامی طور پر ہوتی ہے اور تصاویر آپ کے ڈیوائس سے باہر نہیں جاتیں۔' },
      { q: 'کیا یہ امیج کمپریسنگ ٹول مفت ہے؟', a: 'جی ہاں۔ ہمارا امیج کمپریسر ہمیشہ کے لیے مکمل طور پر مفت ہے۔ ہم کسی قسم کی ادائیگی نہیں مانگتے، کوئی خفیہ چارجز نہیں ہیں، اور متعدد تصاویر کی کمپریشن سمیت تمام فیچرز مفت ہیں۔' },
    ],
    cropImage: [
      { q: 'کیا تصویر کو کراپ کرنے سے اس کی کوالٹی کم ہو جائے گی؟', a: 'نہیں، تصویر کو کراپ کرنے سے تصویر کی بصری کوالٹی پر بالکل بھی اثر نہیں پڑے گا۔ تصویر کو کراپ کرنا صرف غیر ضروری حصوں کو ہٹاتا ہے۔ یہ کراپ کیے جانے والے حصے کے پکسلز کو کبھی تبدیل نہیں کرتا۔ لہٰذا آپ اپنی تصاویر کو اصل کوالٹی میں بغیر کسی پکسل نقصان کے کراپ کر سکتے ہیں۔' },
      { q: 'امیج کراپر کے لیے کون سے امیج فارمیٹس سپورٹ ہوتے ہیں؟', a: 'آپ کسی بھی فارمیٹ کی کوئی بھی تصویر منتخب کر سکتے ہیں کیونکہ ہمارا امیج کراپر ٹول تقریباً تمام امیج فارمیٹس فراہم کرتا ہے۔ یہ نیچے درج ہیں:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'کیا میری تصاویر آپ کے سرور پر اپلوڈ ہوتی ہیں؟', a: 'نہیں، تمام پروسیسنگ آپ کے مقامی براؤزر میں ہوگی۔ آپ کی تصاویر کبھی بھی ہمارے سرور پر اپلوڈ نہیں ہوں گی کیونکہ وہ آپ کے ڈیوائس سے باہر نہیں جاتیں۔ لہٰذا آپ ہمارے امیج کراپر کے ساتھ اپنی ذاتی تصاویر بغیر کسی خطرے کے کراپ کر سکتے ہیں۔' },
      { q: 'کیا میں ایک وقت میں متعدد تصاویر کراپ کر سکتا ہوں؟', a: 'جی ہاں، اگر آپ کا سسٹم سپورٹ کرتا ہو تو آپ ایک وقت میں متعدد تصاویر (حتیٰ کہ 100+) کراپ کر سکتے ہیں۔ چونکہ تصاویر کو کراپ کرنا آپ کے سسٹم کے وسائل استعمال کرتا ہے، اس لیے اگر آپ کے پاس ہائی پرفارمنس لیپ ٹاپ، پی سی یا موبائل ہے تو آپ ایک وقت میں بہت سی تصاویر کراپ کر سکتے ہیں۔ اگر آپ کے پاس کمزور ڈیوائس ہے تو آپ تصاویر کو بیچز میں کراپ کر سکتے ہیں کیونکہ یہ ٹول مفت ہے، چاہے آپ ایک وقت میں متعدد تصاویر کراپ کریں۔' },
      { q: 'کیا یہ امیج کراپر ٹول مفت ہے؟', a: 'جی ہاں، یہ امیج کراپنگ ٹول ہمیشہ کے لیے مکمل طور پر مفت ہے۔ آپ اس ٹول تک کہیں بھی، کسی بھی وقت، اور کسی بھی ڈیوائس پر رسائی حاصل کر سکتے ہیں۔ آپ کو نہ صرف تمام ڈیوائسز کے لیے responsive design ملے گا بلکہ آپ سے کسی premium feature کے لیے کبھی ادائیگی بھی نہیں مانگی جائے گی۔ تمام فیچرز مکمل طور پر مفت ہیں اور کوئی hidden charges نہیں ہیں۔' },
    ],
    resizeImage: [
      { q: 'کیا میں ایک ساتھ متعدد تصاویر کا سائز تبدیل کر سکتا ہوں؟', a: 'جی ہاں، بالکل۔ ہمارا ٹول ایک وقت میں متعدد تصاویر کی ری سائزنگ سپورٹ کرتا ہے۔ آپ اپنے ڈیوائس کی صلاحیت کے مطابق تصاویر اپلوڈ کریں، AI انجن انہیں ایک ساتھ پروسیس کر دے گا۔ کمزور ڈیوائس پر بہتر کارکردگی کے لیے بیچز میں کام کریں۔ تمام پروسیسنگ مقامی طور پر ہوتی ہے، سرور اپلوڈ نہیں ہوتا، اس لیے رازداری محفوظ رہتی ہے۔' },
      { q: 'کیا یہ امیج ری سائزنگ ٹول مفت ہے؟', a: 'جی ہاں، یہ ٹول ہمیشہ کے لیے مکمل طور پر مفت ہے۔ پریمیم فیچرز کے لیے کسی paid subscription کی ضرورت نہیں۔ ری سائز شدہ تصاویر ڈاؤن لوڈ کرتے وقت بھی کوئی hidden charges نہیں ہیں۔' },
      { q: 'کیا ری سائز کرنے سے تصویر کی کوالٹی کم ہوتی ہے؟', a: '✅Decrease Size (downscale): تصویر کا سائز کم کرنے سے بصری کوالٹی کم نہیں ہوتی۔ بہت سے مواقع پر کم سائز والی تصویر زیادہ شارپ بھی لگ سکتی ہے۔ اس لیے چھوٹا کرنے سے عموماً معیار متاثر نہیں ہوتا۔\n❌Increase Size (upscale): تصویر کو اصل سائز سے بڑا کرنے پر بصری معیار متاثر ہو سکتا ہے۔ جتنا زیادہ بڑا کریں گے، کوالٹی کم ہونے کا امکان اتنا ہی بڑھتا جائے گا۔' },
      { q: 'کیا یہ ٹول محفوظ ہے؟', a: 'جی ہاں، ہمارا ٹول خاص طور پر ذاتی اور حساس تصاویر کے لیے محفوظ ہے۔ تمام پروسیسنگ آپ کے اپنے ڈیوائس پر ہوتی ہے اور کوئی ڈیٹا باہر نہیں جاتا۔ آپ بغیر پرائیویسی رسک کے تصاویر ری سائز کر سکتے ہیں۔' },
      { q: 'کون سے امیج فارمیٹس سپورٹ ہوتے ہیں؟', a: 'ہمارا امیج ری سائزر تمام فارمیٹس سپورٹ کرتا ہے۔ آپ درج ذیل فارمیٹس میں تصاویر منتخب کر سکتے ہیں:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
    ],
    removeBackground: [
      { q: 'بیک گراؤنڈ ہٹانا کیسے کام کرتا ہے؟', a: 'ہم ایک جدید AI ماڈل استعمال کرتے ہیں جو براہ راست آپ کے براؤزر میں چلتا ہے اور موضوع کو پس منظر سے الگ کرتا ہے۔' },
      { q: 'کیا یہ پیچیدہ پس منظروں کے ساتھ کام کرتا ہے؟', a: 'ہاں۔ AI ماڈل مختلف قسم کے مناظر کو سنبھالتا ہے۔ بہترین نتائج تب ملتے ہیں جب موضوع اور پس منظر کا تضاد واضح ہو۔' },
      { q: 'کیا میں ایک ساتھ متعدد تصاویر کا بیک گراؤنڈ ہٹا سکتا ہوں؟', a: 'ہاں۔ متعدد تصاویر اپلوڈ کریں اور ٹول انہیں یکے بعد دیگرے پروسیس کرے گا۔ تمام نتائج ZIP میں ڈاؤن لوڈ کریں۔' },
      { q: 'آؤٹ پٹ فارمیٹ کیا ہے؟', a: 'آؤٹ پٹ ہمیشہ شفاف پس منظر کے ساتھ PNG فائل ہوتی ہے۔' },
      { q: 'کیا میری تصاویر کسی سرور پر بھیجی جاتی ہیں؟', a: 'نہیں۔ AI ماڈل WebAssembly کا استعمال کرتے ہوئے مکمل طور پر آپ کے براؤزر میں چلتا ہے۔' },
    ],
    watermarkImage: [
      { q: '1. کیا Photremium کا واٹر مارک ٹول مکمل طور پر مفت ہے؟', a: 'جی ہاں، photremium.com/watermark-image پر موجود واٹر مارک ٹول بغیر کسی اکاؤنٹ اور بغیر کسی سبسکرپشن کے مفت استعمال کیا جا سکتا ہے۔ آپ ایک تصویر یا پوری بیچ پر واٹر مارک لگا سکتے ہیں، اور نہ تو کوئی paywall ہے، نہ لازمی رجسٹریشن کا مطالبہ، اور نہ ہی ڈاؤن لوڈ کی کوئی حد۔ یہ ٹول اس لیے مفت رکھا گیا ہے کہ پوری Photremium پلیٹ فارم اتنی مفید ہو کہ لوگ خود واپس آئیں، نہ کہ انفرادی فیچرز کو بند کر کے کمائی کی جائے۔' },
      { q: '2. میں ایک وقت میں کتنی تصاویر پر واٹر مارک لگا سکتا ہوں؟', a: 'یہ ٹول ایک ساتھ کئی تصاویر پر batch watermarking کو سپورٹ کرتا ہے۔ آپ تصاویر کا پورا فولڈر upload zone پر drag and drop کر سکتے ہیں، یا file picker میں Ctrl+Click استعمال کر کے ایک ساتھ درجنوں فائلیں منتخب کر سکتے ہیں۔ بائیں طرف thumbnail strip سب تصاویر دکھاتی ہے، اور جب آپ “Watermark & Download All” پر کلک کرتے ہیں تو ٹول آپ کے مقرر کردہ watermark layers کے ساتھ ہر تصویر render کرتا ہے، پھر انہیں ایک ZIP فائل میں پیک کرتا ہے یا الگ الگ فائلوں کے طور پر ڈاؤن لوڈ کر دیتا ہے۔ عملی طور پر اس batch size کی حد آپ کے device کی memory ہے، نہ کہ ٹول کی کوئی مصنوعی limit۔' },
      { q: '3. ان پٹ اور آؤٹ پٹ کے لیے کون سے image formats سپورٹ ہیں؟', a: 'ان پٹ کے طور پر وہ تمام image formats قبول ہوتے ہیں جنہیں browser کا File API سنبھال سکتا ہے، یعنی JPEG، JPG، PNG، WEBP، GIF (static)، BMP، اور SVG۔ آؤٹ پٹ میں format اصل image کے مطابق رہتا ہے: اگر آپ PNG اپلوڈ کریں گے تو PNG واپس ملے گا؛ اگر JPEG اپلوڈ کریں گے تو 0.95 quality کے ساتھ JPEG ملے گا۔ یہ format-preservation approach اس بات کو یقینی بناتی ہے کہ آپ غلطی سے lossless PNG کو lossy JPEG میں تبدیل نہ کر بیٹھیں۔' },
      { q: '4. کیا مختلف resolutions والی تصاویر پر میرا واٹر مارک ایک جیسا نظر آئے گا؟', a: 'جی ہاں، یہ tool کے proportional repositioning engine کی بدولت ممکن ہے۔ جب آپ مختلف dimensions والی تصاویر کی batch رکھتے ہیں تو واٹر مارک reference image پر author کیا جاتا ہے، یعنی وہی تصویر جو canvas میں منتخب ہو۔ Export کے وقت engine reference image پر ہر watermark layer کا center of gravity نکالتا ہے، اس position کو image center سے fractional offset کی صورت میں بیان کرتا ہے، اور ہر target image پر وہی proportional offset لاگو کرتا ہے۔ واٹر مارک کا سائز بھی proportionally scale ہوتا ہے اور دو scale factors میں سے چھوٹے والے کے مطابق adjust ہوتا ہے، یعنی width ratio یا height ratio، تاکہ وہ تصویر کی boundaries سے باہر نہ نکلے۔ نتیجہ یہ ہوتا ہے کہ چاہے تصاویر کے dimensions مختلف ہوں، واٹر مارک اپنی relative position اور size برقرار رکھتا ہے۔' },
      { q: '5. کیا میں text کے بجائے اپنی logo یا signature کو واٹر مارک کے طور پر استعمال کر سکتا ہوں؟', a: 'بالکل۔ دائیں panel میں موجود “Add Image” button آپ کو device سے کوئی بھی image upload کرنے دیتا ہے تاکہ اسے watermark layer کے طور پر استعمال کیا جا سکے۔ Transparent background والی PNG files سب سے بہتر کام کرتی ہیں، کیونکہ transparency برقرار رہتی ہے اور لوگو کے پیچھے سفید یا colored box نہیں آتا۔ آپ corner handles کھینچ کر size بدل سکتے ہیں، rotate کر سکتے ہیں، flip کر سکتے ہیں، opacity adjust کر سکتے ہیں، اور border یا rounded corners بھی شامل کر سکتے ہیں۔ بہت سے صارفین اپنے لوگو کا transparent version خاص طور پر watermarking کے لیے محفوظ رکھتے ہیں۔' },
      { q: '6. میں اپنے واٹر مارک کو شفاف یا نیم شفاف کیسے بناؤں؟', a: 'Canvas پر watermark layer کو click کر کے منتخب کریں۔ اوپر ظاہر ہونے والی toolbar میں opacity control دیکھیں، جو فیصد دکھاتا ہے اور آپ کو براہ راست number لکھنے یا value scrub کرنے دیتا ہے۔ اگر آپ ایسا watermark چاہتے ہیں جو تصویر پر غالب نہ آئے مگر پیشہ ورانہ لگے تو 30–50% opacity بہترین سمجھی جاتی ہے۔ زیادہ واضح copyright notice کے لیے جو آسانی سے نظر آئے، 70–80% opacity مناسب رہتی ہے۔ آپ layer manager میں eye icon سے layer visibility toggle کر کے فوری comparison بھی کر سکتے ہیں تاکہ تصویر watermark کے ساتھ اور بغیر دونوں حالتوں میں دیکھی جا سکے۔' },
      { q: '7. کیا میں ایک ہی تصویر میں متعدد واٹر مارکس شامل کر سکتا ہوں؟', a: 'جی ہاں، layer system لامحدود watermark layers کو سپورٹ کرتا ہے، اور ہر ایک کو الگ الگ configure کیا جا سکتا ہے۔ آپ نیچے دائیں کونے میں text copyright notice، اوپر بائیں کونے میں logo، اور ایک tiled “SAMPLE” overlay ایک ساتھ رکھ سکتے ہیں۔ ہر layer کی اپنی opacity، rotation، position، size اور styling settings ہوتی ہیں۔ دائیں panel کا layer manager انہیں منظم رکھتا ہے، اور آپ بغیر حذف کیے individual layers کو آن یا آف کر سکتے ہیں، جس سے مختلف combinations آزمانا آسان ہو جاتا ہے۔' },
      { q: '8. Tiling feature کیا کرتا ہے اور مجھے اسے کب استعمال کرنا چاہیے؟', a: 'Tiling آپ کے watermark کو پوری تصویر پر grid pattern میں دہراتا ہے۔ Grid 2×2 option چار copies کو دو بائی دو ترتیب میں رکھتا ہے؛ Grid 3×3 نو copies کو تین بائی تین ترتیب میں رکھتا ہے۔ tile spacing control copies کے درمیان gaps کو adjust کرتا ہے۔ Tiling اس وقت سب سے مفید ہے جب آپ کسی تصویر کو اجازت کے بغیر استعمال کے قابل نہ رکھنا چاہیں۔ ایک کونے والا watermark آسانی سے crop ہو سکتا ہے، لیکن مکمل coverage والا tile pattern تصویر کو واٹر مارک کے بغیر عملاً ناقابلِ استعمال بنا دیتا ہے۔ یہ طریقہ contract previews، client approval کے لیے draft illustrations، یا ایسے content کے لیے مفید ہے جو payment سے پہلے freely استعمال نہ ہونا چاہیے۔' },
      { q: '9. کیا یہ tool موبائل فونز اور tablets پر کام کرتا ہے؟', a: 'جی ہاں، یہ tool مکمل طور پر responsive ہے اور mobile use کے لیے بنایا گیا ہے۔ 900 pixels سے کم چوڑائی والی screens پر تین-panel layout stacked layout میں بدل جاتا ہے: image thumbnail strip اوپر horizontal scrollable row بن جاتی ہے، canvas main area بھر دیتا ہے، اور settings panel ایک bottom sheet بن جاتا ہے جو floating gear button پر tap کرنے سے اوپر آتا ہے۔ تمام interactive elements، یعنی layer dragging، resizing handles اور rotation، touch-enabled ہیں اور touchstart و touchmove events استعمال کرتے ہیں۔ resize handles mobile پر قدرے بڑے، یعنی 16×16 pixels، رکھے گئے ہیں تاکہ انگلی سے آسانی سے درست جگہ پر tap کیا جا سکے۔' },
      { q: '10. کیا میری image data private ہے؟ کیا میری photos کسی server پر upload ہوتی ہیں؟', a: 'آپ کی تصاویر کبھی آپ کے device سے باہر نہیں جاتیں۔ پورا watermark workflow، یعنی images load کرنا، layers render کرنا اور final file export کرنا، آپ کے browser میں JavaScript اور HTML5 Canvas API کے ذریعے ہوتا ہے۔ جب آپ تصویر upload کرتے ہیں تو File API اس file کی in-memory representation بناتا ہے۔ جب آپ watermark layer شامل کرتے ہیں تو وہ ایک off-screen canvas element پر draw ہوتی ہے۔ جب آپ نتیجہ download کرتے ہیں تو canvas کا pixel data Blob میں تبدیل ہو کر browser کو download کے لیے دے دیا جاتا ہے، اور سب کچھ locally ہوتا ہے۔ image data شامل کرنے والی کوئی network request نہیں کی جاتی۔ مزید یہ کہ tool میں page-unload guard بھی شامل ہے: اگر آپ images load ہونے کے دوران page بند کرنے یا کہیں اور جانے کی کوشش کریں تو browser آپ سے confirm کرنے کو کہتا ہے تاکہ کام ضائع نہ ہو۔' },
    ],
    qrCodeGenerator: [
      { q: 'کیا یہ QR کوڈ ایکسپائر ہوتا ہے؟', a: 'نہیں، یہ QR کوڈز ایکسپائر نہیں ہوتے اور تاحیات قابلِ استعمال رہتے ہیں۔ چونکہ یہ مربع خانوں میں بِٹس کی شکل میں ہارڈ کوڈڈ ہدایات محفوظ کرتے ہیں، اس لیے ان میں محفوظ معلومات کو تبدیل یا حذف نہیں کیا جا سکتا۔ آپ برسوں بعد بھی کسی بھی کیمرے سے اسکین کر کے اس کوڈ میں موجود معلومات تک رسائی حاصل کر سکتے ہیں۔' },
      { q: 'میرا QR کوڈ اسکین کیوں نہیں ہو رہا؟', a: 'آپ کا QR کوڈ درج ذیل وجوہات کی بنا پر اسکین نہیں ہو سکتا: i. کم کنٹراسٹ: اگر پس منظر اور پیش منظر کے رنگ بہت ملتے جلتے ہوں تو QR کوڈ کی مرئیت متاثر ہوتی ہے اور اسکیننگ ناکام ہو سکتی ہے۔ ہمارا ٹول کسٹمائزیشن کے دوران کم کنٹراسٹ اور دیگر اسکیننگ مسائل کے بارے میں رہنمائی دیتا ہے۔ ii. بہت زیادہ ڈیٹا: اگر آپ بہت بڑا متن شامل کرتے ہیں تو QR کوڈ بہت پیچیدہ ہو جاتا ہے اور اسکین کرنا مشکل ہو جاتا ہے۔ متن کی لمبائی کا ویلیڈیٹر بہترین لمبائی کے بارے میں رہنمائی دیتا ہے۔ iii. دھندلا پرنٹ: اپنے QR کوڈ کو PNG یا SVG جیسے ہائی ریزولوشن فارمیٹ میں ڈاؤن لوڈ کریں، جو ہمارے ٹول میں پہلے سے سپورٹڈ ہیں۔' },
      { q: 'کیا میں QR کوڈ میں لوگو شامل کر سکتا ہوں؟', a: 'بالکل۔ آپ اپنا کسٹم لوگو شامل کر سکتے ہیں یا اِن بلٹ لوگو لائبریری سے کوئی لوگو منتخب کر سکتے ہیں۔ منتخب کردہ لوگو خودکار طور پر QR کوڈ کے درمیان میں درست انداز سے ایڈجسٹ ہو جائے گا۔' },
      { q: 'میں QR کوڈ کیسے اسکین کر سکتا ہوں؟', a: 'آپ اپنے موبائل کیمرے سے QR کوڈ اسکین کر سکتے ہیں۔ لیکن خودکار لنک ری ڈائریکشن اور مزید جدید فیچرز کے لیے آپ مفت میں https://photremium.com/qr-code-scanner پر ہمارے QR کوڈ اسکینر کا استعمال کر سکتے ہیں۔' },
      { q: 'میں مفت میں کتنے QR کوڈ بنا سکتا ہوں؟', a: 'لامحدود! آپ مفت میں جتنے چاہیں QR کوڈ بنا سکتے ہیں۔ تمام فیچرز، کسٹمائزیشنز اور ٹیمپلیٹس سب کے لیے ہمیشہ مفت ہیں۔ پریمیئم فیچرز استعمال کرنے کے لیے کسی سبسکرپشن کی ضرورت نہیں۔' },
      { q: 'کیا QR کوڈ بنانے کے لیے لاگ اِن/سائن اَپ ضروری ہے؟', a: 'نہیں۔ بس اپنا متن درج کریں، QR کوڈ بنائیں اور کسٹمائزیشن کے بعد ڈاؤن لوڈ کر لیں۔ لاگ اِن یا سائن اَپ کی ضرورت نہیں، کیونکہ تمام فیچرز مکمل طور پر مفت دستیاب ہیں۔' },
    ],
    qrCodeScanner: [
      { q: 'کیا میں محفوظ تصاویر اور اسکرین شاٹس سے QR کوڈ اسکین کر سکتا ہوں؟', a: '**ہاں**، آپ محفوظ تصاویر یا اسکرین شاٹس سے QR کوڈ اسکین کر سکتے ہیں۔ ہمارا QR کوڈ اسکینر https://photremium.com/qr-code-scanner آپ کو گیلری سے QR کوڈ اسکین کرنے دیتا ہے۔ آپ کو صرف تصویر منتخب کرنی ہے اور آپ کو اس QR کوڈ سے حاصل شدہ تمام ڈیکوڈ شدہ معلومات مل جائیں گی۔' },
      { q: 'کیا QR کوڈ اسکینر کے لیے ایپ انسٹال کرنا ضروری ہے؟', a: '**نہیں**، ہمارا ویب بیسڈ QR کوڈ اسکینر بغیر کسی ایپ انسٹالیشن کے QR کوڈ اسکین کرنے دیتا ہے۔ آپ ہمارے ایڈوانس QR کوڈ اسکینر کو کسی بھی ڈیوائس پر مفت استعمال کر سکتے ہیں۔' },
      { q: 'اسکینر QR کوڈ کو کیوں نہیں پہچان رہا؟', a: 'آپ کا QR کوڈ درج ذیل میں سے کسی وجہ سے اسکین نہیں ہو رہا: i. ناکافی روشنی: کم روشنی میں QR کوڈ اسکین کرنے سے مسئلہ ہو سکتا ہے۔ اگر آپ اسکرین سے اسکین کر رہے ہیں تو ٹارچ آن کریں اور برائٹنس بڑھائیں۔ ii. فاصلہ: نامناسب فاصلے سے اسکین کرنے سے بھی مسئلہ ہوتا ہے۔ QR کوڈ اسکین کرنے کے لیے بہترین فاصلہ تقریباً 10 انچ (25cm) ہے۔ iii. گندا کیمرا لینس: QR کوڈ گندے لینس کی وجہ سے بھی اسکین نہیں ہوتا۔ اسکین سے پہلے لینس صاف کریں۔ “کیا آپ کو اسکینر میں باکس گرڈ نظر آ رہا ہے؟ QR کوڈ کو اس کے اندر فِٹ کریں، یہ کامیابی سے اسکین ہو جائے گا۔”' },
      { q: 'کیا یہ ٹول الٹے یا رنگین QR کوڈ کو اسکین کر سکتا ہے؟', a: '**ہاں**، آپ کسی بھی رنگ یا سمت میں QR اسکین کر سکتے ہیں۔ تاہم اگر بیک گراؤنڈ اور فورگراؤنڈ رنگوں کا کنٹراسٹ کم ہو تو اسکین کرنے میں دشواری ہو سکتی ہے۔' },
      { q: 'کیا یہ ٹول مفت ہے؟', a: '**ہاں**، یہ ٹول مکمل طور پر مفت ہے۔ آپ ہمیشہ کے لیے لامحدود QR کوڈز مفت اسکین کر سکتے ہیں۔' },
    ],
    faceBlur: [
      { q: 'فیس ڈیٹیکشن کیسے کام کرتی ہے؟', a: 'ہم ایک AI پاورڈ فیس ڈیٹیکشن ماڈل استعمال کرتے ہیں جو براہ راست آپ کے براؤزر میں چلتا ہے اور تصویر میں چہرے شناخت کرتا ہے۔' },
      { q: 'کیا میں چن سکتا ہوں کہ کون سے چہرے بلر کریں؟', a: 'ہاں۔ ڈیٹیکشن کے بعد ہر چہرے کا علاقہ ہائی لائٹ ہوتا ہے اور آپ انتخاب کر سکتے ہیں کہ کون سے بلر کرنے ہیں۔' },
      { q: 'کون سے بلر اسٹائلز دستیاب ہیں؟', a: 'آپ گاؤسیئن بلر، پکسلیشن یا سولڈ کلر اوورلے میں سے چن سکتے ہیں جن کی شدت مکمل طور پر ایڈجسٹ ہوتی ہے۔' },
      { q: 'کیا میں ایک ساتھ متعدد تصاویر میں چہرے بلر کر سکتا ہوں؟', a: 'ہاں۔ متعدد تصاویر اپلوڈ کریں، بلر ریجنز ترتیب دیں اور تمام پروسیس شدہ تصاویر ڈاؤن لوڈ کریں۔' },
      { q: 'کیا میری تصاویر کسی ریموٹ سرور پر بھیجی جاتی ہیں؟', a: 'نہیں۔ AI ماڈل WebAssembly کا استعمال کرتے ہوئے آپ کے براؤزر میں چلتا ہے۔ آپ کی تصاویر کبھی سرور پر اپلوڈ نہیں ہوتیں۔' },
    ],
    photoEditor: [
      { q: 'کون سی ایڈیٹنگ سہولیات دستیاب ہیں؟', a: 'آپ روشنی، کنٹراسٹ، سیچوریشن ایڈجسٹ کر سکتے ہیں، فلٹرز لگا سکتے ہیں، ٹیکسٹ، اوورلیز، فریمز، اسٹیکرز اور بہت کچھ شامل کر سکتے ہیں — سب براؤزر میں۔' },
      { q: 'کیا میں تبدیلیاں انڈو اور ریڈو کر سکتا ہوں؟', a: 'ہاں۔ ایڈیٹر مکمل انڈو/ریڈو ہسٹری سپورٹ کرتا ہے۔' },
      { q: 'میں کون سے فائل فارمیٹس ایڈٹ اور ایکسپورٹ کر سکتا ہوں؟', a: 'آپ JPG، PNG، WEBP اور دیگر عام فارمیٹس ایڈٹ کر سکتے ہیں۔ ایڈٹ شدہ تصویر کو اپنی پسند کے فارمیٹ میں ایکسپورٹ کریں۔' },
      { q: 'کیا ایڈیٹر موبائل پر کام کرتا ہے؟', a: 'ہاں۔ ایڈیٹر مکمل طور پر ریسپانسو اور ٹچ فرینڈلی ہے۔' },
      { q: 'کیا میری تصاویر آپ کے سرورز پر محفوظ ہوتی ہیں؟', a: 'نہیں۔ تمام ایڈیٹنگ مقامی طور پر ہوتی ہے۔ آپ کی تصاویر کبھی آپ کے ڈیوائس سے باہر نہیں جاتیں۔' },
    ],
  },
};

export default ur;